var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceicon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 82,
    viewBox: "0 0 92 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M23.5344 71.5204C44.167 85.0022 84.3121 89.2005 90.6787 57.3289C93.8031 41.7775 80.0087 32.4939 76.4127 18.5981C73.8779 8.72325 65.8017 5.23452 56.5465 9.19629C38.0361 17.179 -14.6654 14.8729 3.90395 50.8245C7.91256 58.6298 15.0455 65.9029 23.5344 71.5204Z",
    fill: "#C9ACFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9283 44.7341C59.865 44.9239 59.7385 45.0504 59.5488 45.0504C59.4223 45.0504 59.2958 44.9871 59.2325 44.9239C59.5488 44.7974 59.7385 44.7974 59.9283 44.7341Z",
    fill: "url(#paint0_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 44.6692C62.7728 44.859 62.583 45.0487 62.3933 45.0487C62.2035 45.0487 62.0138 44.859 62.0138 44.6692C62.0138 44.606 62.0138 44.5427 62.0138 44.5427C62.1403 44.5427 62.2668 44.5427 62.3933 44.5427C62.5198 44.5427 62.583 44.5427 62.7095 44.5427C62.7728 44.5427 62.7728 44.606 62.7728 44.6692Z",
    fill: "url(#paint1_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.4939 44.8606C65.4307 44.9871 65.3042 45.0504 65.1777 45.0504C64.9879 45.0504 64.8615 44.9239 64.8615 44.7341C65.0512 44.7341 65.3042 44.7974 65.4939 44.8606Z",
    fill: "url(#paint2_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 46.3773C57.1439 46.5671 56.9541 46.7568 56.7644 46.7568C56.5746 46.7568 56.3849 46.6303 56.3849 46.3773C56.3849 46.1876 56.5746 45.9978 56.7644 45.9978C57.0174 46.0611 57.1439 46.1876 57.1439 46.3773Z",
    fill: "url(#paint3_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 46.3773C59.9271 46.5671 59.8006 46.7568 59.5476 46.7568C59.3578 46.7568 59.1681 46.6303 59.1681 46.3773C59.1681 46.1876 59.2946 45.9978 59.5476 45.9978C59.8006 46.0611 59.9271 46.1876 59.9271 46.3773Z",
    fill: "url(#paint4_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 46.3773C62.7728 46.5671 62.583 46.7568 62.3933 46.7568C62.2035 46.7568 62.0138 46.6303 62.0138 46.3773C62.0138 46.1876 62.2035 45.9978 62.3933 45.9978C62.583 46.0611 62.7728 46.1876 62.7728 46.3773Z",
    fill: "url(#paint5_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 46.3773C65.556 46.5671 65.4295 46.7568 65.1765 46.7568C64.9867 46.7568 64.797 46.6303 64.797 46.3773C64.797 46.1876 64.9235 45.9978 65.1765 45.9978C65.3662 46.0611 65.556 46.1876 65.556 46.3773Z",
    fill: "url(#paint6_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 46.3773C68.3411 46.5671 68.1514 46.7568 67.9617 46.7568C67.7719 46.7568 67.5822 46.6303 67.5822 46.3773C67.5822 46.1876 67.7719 45.9978 67.9617 45.9978C68.2147 46.0611 68.3411 46.1876 68.3411 46.3773Z",
    fill: "url(#paint7_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 48.274C54.3607 48.4638 54.1709 48.6535 53.9812 48.6535C53.7914 48.6535 53.6017 48.4638 53.6017 48.274C53.6017 48.0843 53.7282 47.8945 53.9812 47.8945C54.2342 47.8945 54.3607 48.0843 54.3607 48.274Z",
    fill: "url(#paint8_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M56.8269 48.6533C57.0365 48.6533 57.2064 48.4834 57.2064 48.2738C57.2064 48.0642 57.0365 47.8943 56.8269 47.8943C56.6173 47.8943 56.4474 48.0642 56.4474 48.2738C56.4474 48.4834 56.6173 48.6533 56.8269 48.6533Z",
    fill: "url(#paint9_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 48.2738C59.9271 48.4635 59.8006 48.6533 59.5476 48.6533C59.3578 48.6533 59.1681 48.4635 59.1681 48.2738C59.1681 48.084 59.2946 47.8943 59.5476 47.8943C59.8006 47.8943 59.9271 48.084 59.9271 48.2738Z",
    fill: "url(#paint10_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3933 48.6533C62.6029 48.6533 62.7728 48.4834 62.7728 48.2738C62.7728 48.0642 62.6029 47.8943 62.3933 47.8943C62.1837 47.8943 62.0138 48.0642 62.0138 48.2738C62.0138 48.4834 62.1837 48.6533 62.3933 48.6533Z",
    fill: "url(#paint11_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.5562 48.274C65.5562 48.4638 65.4297 48.6535 65.1767 48.6535C64.987 48.6535 64.7972 48.4638 64.7972 48.274C64.7972 48.0843 64.9237 47.8945 65.1767 47.8945C65.3665 47.8945 65.5562 48.0843 65.5562 48.274Z",
    fill: "url(#paint12_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.9617 48.6533C68.1712 48.6533 68.3411 48.4834 68.3411 48.2738C68.3411 48.0642 68.1712 47.8943 67.9617 47.8943C67.7521 47.8943 67.5822 48.0642 67.5822 48.2738C67.5822 48.4834 67.7521 48.6533 67.9617 48.6533Z",
    fill: "url(#paint13_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 48.2738C71.1224 48.4635 70.9959 48.6533 70.7429 48.6533C70.5531 48.6533 70.3634 48.4635 70.3634 48.2738C70.3634 48.084 70.4899 47.8943 70.7429 47.8943C70.9959 47.8943 71.1224 48.084 71.1224 48.2738Z",
    fill: "url(#paint14_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5799 50.1715C51.5799 50.3612 51.3901 50.551 51.2004 50.551C51.0739 50.551 51.0106 50.4877 50.9474 50.4245C51.0739 50.2347 51.2004 50.045 51.3901 49.8552C51.5166 49.9185 51.5799 50.045 51.5799 50.1715Z",
    fill: "url(#paint15_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 50.1742C54.3607 50.3639 54.1709 50.5537 53.9812 50.5537C53.7914 50.5537 53.6017 50.3639 53.6017 50.1742C53.6017 49.9844 53.7282 49.7947 53.9812 49.7947C54.2342 49.7947 54.3607 49.9844 54.3607 50.1742Z",
    fill: "url(#paint16_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M56.8269 50.5537C57.0365 50.5537 57.2064 50.3838 57.2064 50.1742C57.2064 49.9646 57.0365 49.7947 56.8269 49.7947C56.6173 49.7947 56.4474 49.9646 56.4474 50.1742C56.4474 50.3838 56.6173 50.5537 56.8269 50.5537Z",
    fill: "url(#paint17_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 50.1742C59.9271 50.3639 59.8006 50.5537 59.5476 50.5537C59.3578 50.5537 59.1681 50.3639 59.1681 50.1742C59.1681 49.9844 59.2946 49.7947 59.5476 49.7947C59.8006 49.7947 59.9271 49.9844 59.9271 50.1742Z",
    fill: "url(#paint18_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3933 50.5537C62.6029 50.5537 62.7728 50.3838 62.7728 50.1742C62.7728 49.9646 62.6029 49.7947 62.3933 49.7947C62.1837 49.7947 62.0138 49.9646 62.0138 50.1742C62.0138 50.3838 62.1837 50.5537 62.3933 50.5537Z",
    fill: "url(#paint19_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 50.1742C65.556 50.3639 65.4295 50.5537 65.1765 50.5537C64.9867 50.5537 64.797 50.3639 64.797 50.1742C64.797 49.9844 64.9235 49.7947 65.1765 49.7947C65.3662 49.7947 65.556 49.9844 65.556 50.1742Z",
    fill: "url(#paint20_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.9617 50.5537C68.1712 50.5537 68.3411 50.3838 68.3411 50.1742C68.3411 49.9646 68.1712 49.7947 67.9617 49.7947C67.7521 49.7947 67.5822 49.9646 67.5822 50.1742C67.5822 50.3838 67.7521 50.5537 67.9617 50.5537Z",
    fill: "url(#paint21_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 50.1742C71.1224 50.3639 70.9959 50.5537 70.7429 50.5537C70.5531 50.5537 70.3634 50.3639 70.3634 50.1742C70.3634 49.9844 70.4899 49.7947 70.7429 49.7947C70.9959 49.7947 71.1224 49.9844 71.1224 50.1742Z",
    fill: "url(#paint22_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9068 50.3612C73.8436 50.4877 73.7171 50.551 73.5906 50.551C73.4008 50.551 73.2111 50.3612 73.2111 50.1715C73.2111 49.9817 73.3376 49.8552 73.4641 49.8552C73.5906 49.9817 73.7803 50.1715 73.9068 50.3612Z",
    fill: "url(#paint23_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 52.0726C51.5794 52.2624 51.3897 52.4521 51.1999 52.4521C51.0102 52.4521 50.8204 52.3256 50.8204 52.0726C50.8204 51.8829 51.0102 51.6931 51.1999 51.6931C51.3897 51.6931 51.5794 51.8196 51.5794 52.0726Z",
    fill: "url(#paint24_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 52.0726C54.3607 52.2624 54.1709 52.4521 53.9812 52.4521C53.7914 52.4521 53.6017 52.3256 53.6017 52.0726C53.6017 51.8829 53.7282 51.6931 53.9812 51.6931C54.2342 51.6931 54.3607 51.8196 54.3607 52.0726Z",
    fill: "url(#paint25_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 52.0726C57.1439 52.2624 56.9541 52.4521 56.7644 52.4521C56.5746 52.4521 56.3849 52.3256 56.3849 52.0726C56.3849 51.8829 56.5746 51.6931 56.7644 51.6931C57.0174 51.6931 57.1439 51.8196 57.1439 52.0726Z",
    fill: "url(#paint26_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 52.0726C59.9271 52.2624 59.8006 52.4521 59.5476 52.4521C59.3578 52.4521 59.1681 52.3256 59.1681 52.0726C59.1681 51.8829 59.2946 51.6931 59.5476 51.6931C59.8006 51.6931 59.9271 51.8196 59.9271 52.0726Z",
    fill: "url(#paint27_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 52.0726C62.7728 52.2624 62.583 52.4521 62.3933 52.4521C62.2035 52.4521 62.0138 52.3256 62.0138 52.0726C62.0138 51.8829 62.2035 51.6931 62.3933 51.6931C62.583 51.6931 62.7728 51.8196 62.7728 52.0726Z",
    fill: "url(#paint28_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 52.0726C65.556 52.2624 65.4295 52.4521 65.1765 52.4521C64.9867 52.4521 64.797 52.3256 64.797 52.0726C64.797 51.8829 64.9235 51.6931 65.1765 51.6931C65.3662 51.6931 65.556 51.8196 65.556 52.0726Z",
    fill: "url(#paint29_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 52.0726C68.3411 52.2624 68.1514 52.4521 67.9617 52.4521C67.7719 52.4521 67.5822 52.3256 67.5822 52.0726C67.5822 51.8829 67.7719 51.6931 67.9617 51.6931C68.2147 51.6931 68.3411 51.8196 68.3411 52.0726Z",
    fill: "url(#paint30_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 52.0726C71.1224 52.2624 70.9959 52.4521 70.7429 52.4521C70.5531 52.4521 70.3634 52.3256 70.3634 52.0726C70.3634 51.8829 70.4899 51.6931 70.7429 51.6931C70.9959 51.6931 71.1224 51.8196 71.1224 52.0726Z",
    fill: "url(#paint31_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 52.0726C73.9701 52.2624 73.7803 52.4521 73.5906 52.4521C73.4008 52.4521 73.2111 52.3256 73.2111 52.0726C73.2111 51.8829 73.4008 51.6931 73.5906 51.6931C73.7803 51.6931 73.9701 51.8196 73.9701 52.0726Z",
    fill: "url(#paint32_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 53.8988C51.5794 54.0885 51.3897 54.2783 51.1999 54.2783C51.0102 54.2783 50.8204 54.0885 50.8204 53.8988C50.8204 53.709 51.0102 53.5193 51.1999 53.5193C51.3897 53.5825 51.5794 53.709 51.5794 53.8988Z",
    fill: "url(#paint33_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 53.8988C54.3607 54.0885 54.1709 54.2783 53.9812 54.2783C53.7914 54.2783 53.6017 54.0885 53.6017 53.8988C53.6017 53.709 53.7282 53.5193 53.9812 53.5193C54.2342 53.5193 54.3607 53.709 54.3607 53.8988Z",
    fill: "url(#paint34_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 53.8988C57.1439 54.0885 56.9541 54.2783 56.7644 54.2783C56.5746 54.2783 56.3849 54.0885 56.3849 53.8988C56.3849 53.709 56.5746 53.5193 56.7644 53.5193C57.0174 53.5825 57.1439 53.709 57.1439 53.8988Z",
    fill: "url(#paint35_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 53.8988C59.9271 54.0885 59.8006 54.2783 59.5476 54.2783C59.3578 54.2783 59.1681 54.0885 59.1681 53.8988C59.1681 53.709 59.2946 53.5193 59.5476 53.5193C59.8006 53.5825 59.9271 53.709 59.9271 53.8988Z",
    fill: "url(#paint36_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 53.8988C62.7728 54.0885 62.583 54.2783 62.3933 54.2783C62.2035 54.2783 62.0138 54.0885 62.0138 53.8988C62.0138 53.709 62.2035 53.5193 62.3933 53.5193C62.583 53.5825 62.7728 53.709 62.7728 53.8988Z",
    fill: "url(#paint37_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 53.8988C65.556 54.0885 65.4295 54.2783 65.1765 54.2783C64.9867 54.2783 64.797 54.0885 64.797 53.8988C64.797 53.709 64.9235 53.5193 65.1765 53.5193C65.3662 53.5825 65.556 53.709 65.556 53.8988Z",
    fill: "url(#paint38_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 53.8988C68.3411 54.0885 68.1514 54.2783 67.9617 54.2783C67.7719 54.2783 67.5822 54.0885 67.5822 53.8988C67.5822 53.709 67.7719 53.5193 67.9617 53.5193C68.2147 53.5825 68.3411 53.709 68.3411 53.8988Z",
    fill: "url(#paint39_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 53.8988C71.1224 54.0885 70.9959 54.2783 70.7429 54.2783C70.5531 54.2783 70.3634 54.0885 70.3634 53.8988C70.3634 53.709 70.4899 53.5193 70.7429 53.5193C70.9959 53.5825 71.1224 53.709 71.1224 53.8988Z",
    fill: "url(#paint40_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 53.8988C73.9701 54.0885 73.7803 54.2783 73.5906 54.2783C73.4008 54.2783 73.2111 54.0885 73.2111 53.8988C73.2111 53.709 73.4008 53.5193 73.5906 53.5193C73.7803 53.5825 73.9701 53.709 73.9701 53.8988Z",
    fill: "url(#paint41_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.923 55.8004C48.923 55.9901 48.7965 56.1166 48.67 56.1166C48.7333 55.9269 48.7333 55.6739 48.7965 55.4841C48.8598 55.6106 48.923 55.6739 48.923 55.8004Z",
    fill: "url(#paint42_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 55.7972C51.5794 55.987 51.3897 56.1767 51.1999 56.1767C51.0102 56.1767 50.8204 55.987 50.8204 55.7972C50.8204 55.6075 51.0102 55.4177 51.1999 55.4177C51.3897 55.4177 51.5794 55.6075 51.5794 55.7972Z",
    fill: "url(#paint43_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 55.7972C54.3607 55.987 54.1709 56.1767 53.9812 56.1767C53.7914 56.1767 53.6017 55.987 53.6017 55.7972C53.6017 55.6075 53.7282 55.4177 53.9812 55.4177C54.2342 55.4177 54.3607 55.6075 54.3607 55.7972Z",
    fill: "url(#paint44_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M56.8269 56.1767C57.0365 56.1767 57.2064 56.0068 57.2064 55.7972C57.2064 55.5876 57.0365 55.4177 56.8269 55.4177C56.6173 55.4177 56.4474 55.5876 56.4474 55.7972C56.4474 56.0068 56.6173 56.1767 56.8269 56.1767Z",
    fill: "url(#paint45_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 55.7972C59.9271 55.987 59.8006 56.1767 59.5476 56.1767C59.3578 56.1767 59.1681 55.987 59.1681 55.7972C59.1681 55.6075 59.2946 55.4177 59.5476 55.4177C59.8006 55.4177 59.9271 55.6075 59.9271 55.7972Z",
    fill: "url(#paint46_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3933 56.1767C62.6029 56.1767 62.7728 56.0068 62.7728 55.7972C62.7728 55.5876 62.6029 55.4177 62.3933 55.4177C62.1837 55.4177 62.0138 55.5876 62.0138 55.7972C62.0138 56.0068 62.1837 56.1767 62.3933 56.1767Z",
    fill: "url(#paint47_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.5562 55.7972C65.5562 55.987 65.4297 56.1767 65.1767 56.1767C64.987 56.1767 64.7972 55.987 64.7972 55.7972C64.7972 55.6075 64.9237 55.4177 65.1767 55.4177C65.3665 55.4177 65.5562 55.6075 65.5562 55.7972Z",
    fill: "url(#paint48_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.9617 56.1767C68.1712 56.1767 68.3411 56.0068 68.3411 55.7972C68.3411 55.5876 68.1712 55.4177 67.9617 55.4177C67.7521 55.4177 67.5822 55.5876 67.5822 55.7972C67.5822 56.0068 67.7521 56.1767 67.9617 56.1767Z",
    fill: "url(#paint49_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 55.7972C71.1224 55.987 70.9959 56.1767 70.7429 56.1767C70.5531 56.1767 70.3634 55.987 70.3634 55.7972C70.3634 55.6075 70.4899 55.4177 70.7429 55.4177C70.9959 55.4177 71.1224 55.6075 71.1224 55.7972Z",
    fill: "url(#paint50_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 55.7972C73.9701 55.987 73.7803 56.1767 73.5906 56.1767C73.4008 56.1767 73.2111 55.987 73.2111 55.7972C73.2111 55.6075 73.4008 55.4177 73.5906 55.4177C73.7803 55.4177 73.9701 55.6075 73.9701 55.7972Z",
    fill: "url(#paint51_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M76.0547 56.1799C75.8649 56.1799 75.7384 55.9901 75.7384 55.8004C75.7384 55.6739 75.8017 55.5474 75.9282 55.4841C75.9914 55.6739 76.0547 55.9269 76.0547 56.1799Z",
    fill: "url(#paint52_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9221 57.6976C48.9221 57.8873 48.7324 58.0771 48.5426 58.0771C48.4794 58.0771 48.4794 58.0771 48.4161 58.0771C48.4161 57.8241 48.4161 57.6343 48.4794 57.3813H48.5426C48.7324 57.3181 48.9221 57.5078 48.9221 57.6976Z",
    fill: "url(#paint53_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 57.7015C51.5794 57.8913 51.3897 58.081 51.1999 58.081C51.0102 58.081 50.8204 57.9545 50.8204 57.7015C50.8204 57.5118 51.0102 57.322 51.1999 57.322C51.3897 57.322 51.5794 57.5118 51.5794 57.7015Z",
    fill: "url(#paint54_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 57.7015C54.3607 57.8913 54.1709 58.081 53.9812 58.081C53.7914 58.081 53.6017 57.9545 53.6017 57.7015C53.6017 57.5118 53.7282 57.322 53.9812 57.322C54.2342 57.322 54.3607 57.5118 54.3607 57.7015Z",
    fill: "url(#paint55_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 57.7015C57.1439 57.8913 56.9541 58.081 56.7644 58.081C56.5746 58.081 56.3849 57.9545 56.3849 57.7015C56.3849 57.5118 56.5746 57.322 56.7644 57.322C57.0174 57.322 57.1439 57.5118 57.1439 57.7015Z",
    fill: "url(#paint56_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 57.7015C59.9271 57.8913 59.8006 58.081 59.5476 58.081C59.3578 58.081 59.1681 57.9545 59.1681 57.7015C59.1681 57.5118 59.2946 57.322 59.5476 57.322C59.8006 57.322 59.9271 57.5118 59.9271 57.7015Z",
    fill: "url(#paint57_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 57.7015C62.7728 57.8913 62.583 58.081 62.3933 58.081C62.2035 58.081 62.0138 57.9545 62.0138 57.7015C62.0138 57.5118 62.2035 57.322 62.3933 57.322C62.583 57.322 62.7728 57.5118 62.7728 57.7015Z",
    fill: "url(#paint58_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 57.7015C65.556 57.8913 65.4295 58.081 65.1765 58.081C64.9867 58.081 64.797 57.9545 64.797 57.7015C64.797 57.5118 64.9235 57.322 65.1765 57.322C65.3662 57.322 65.556 57.5118 65.556 57.7015Z",
    fill: "url(#paint59_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 57.7015C68.3411 57.8913 68.1514 58.081 67.9617 58.081C67.7719 58.081 67.5822 57.9545 67.5822 57.7015C67.5822 57.5118 67.7719 57.322 67.9617 57.322C68.2147 57.322 68.3411 57.5118 68.3411 57.7015Z",
    fill: "url(#paint60_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 57.7015C71.1224 57.8913 70.9959 58.081 70.7429 58.081C70.5531 58.081 70.3634 57.9545 70.3634 57.7015C70.3634 57.5118 70.4899 57.322 70.7429 57.322C70.9959 57.322 71.1224 57.5118 71.1224 57.7015Z",
    fill: "url(#paint61_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 57.7015C73.9701 57.8913 73.7803 58.081 73.5906 58.081C73.4008 58.081 73.2111 57.9545 73.2111 57.7015C73.2111 57.5118 73.4008 57.322 73.5906 57.322C73.7803 57.322 73.9701 57.5118 73.9701 57.7015Z",
    fill: "url(#paint62_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M76.3076 57.9514C76.2444 58.0146 76.1811 58.0146 76.1179 58.0146C75.9281 58.0146 75.7384 57.8881 75.7384 57.6351C75.7384 57.4454 75.8649 57.2556 76.1179 57.2556C76.1811 57.2556 76.2444 57.2556 76.2444 57.2556C76.2444 57.5719 76.3076 57.7616 76.3076 57.9514Z",
    fill: "url(#paint63_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9221 59.5328C48.9221 59.7226 48.7324 59.9123 48.5426 59.9123H48.4794C48.4794 59.6593 48.4161 59.4696 48.4161 59.2166C48.4794 59.2166 48.4794 59.2166 48.5426 59.2166C48.7324 59.2166 48.9221 59.3431 48.9221 59.5328Z",
    fill: "url(#paint64_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 59.5375C51.5794 59.7272 51.3897 59.917 51.1999 59.917C51.0102 59.917 50.8204 59.7272 50.8204 59.5375C50.8204 59.3477 51.0102 59.158 51.1999 59.158C51.3897 59.2212 51.5794 59.3477 51.5794 59.5375Z",
    fill: "url(#paint65_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 59.5375C54.3607 59.7272 54.1709 59.917 53.9812 59.917C53.7914 59.917 53.6017 59.7272 53.6017 59.5375C53.6017 59.3477 53.7282 59.158 53.9812 59.158C54.2342 59.158 54.3607 59.3477 54.3607 59.5375Z",
    fill: "url(#paint66_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M56.8269 59.917C57.0365 59.917 57.2064 59.7471 57.2064 59.5375C57.2064 59.3279 57.0365 59.158 56.8269 59.158C56.6173 59.158 56.4474 59.3279 56.4474 59.5375C56.4474 59.7471 56.6173 59.917 56.8269 59.917Z",
    fill: "url(#paint67_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 59.5375C59.9271 59.7272 59.8006 59.917 59.5476 59.917C59.3578 59.917 59.1681 59.7272 59.1681 59.5375C59.1681 59.3477 59.2946 59.158 59.5476 59.158C59.8006 59.2212 59.9271 59.3477 59.9271 59.5375Z",
    fill: "url(#paint68_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3933 59.917C62.6029 59.917 62.7728 59.7471 62.7728 59.5375C62.7728 59.3279 62.6029 59.158 62.3933 59.158C62.1837 59.158 62.0138 59.3279 62.0138 59.5375C62.0138 59.7471 62.1837 59.917 62.3933 59.917Z",
    fill: "url(#paint69_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 59.5375C65.556 59.7272 65.4295 59.917 65.1765 59.917C64.9867 59.917 64.797 59.7272 64.797 59.5375C64.797 59.3477 64.9235 59.158 65.1765 59.158C65.3662 59.2212 65.556 59.3477 65.556 59.5375Z",
    fill: "url(#paint70_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.9617 59.917C68.1712 59.917 68.3411 59.7471 68.3411 59.5375C68.3411 59.3279 68.1712 59.158 67.9617 59.158C67.7521 59.158 67.5822 59.3279 67.5822 59.5375C67.5822 59.7471 67.7521 59.917 67.9617 59.917Z",
    fill: "url(#paint71_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 59.5375C71.1224 59.7272 70.9959 59.917 70.7429 59.917C70.5531 59.917 70.3634 59.7272 70.3634 59.5375C70.3634 59.3477 70.4899 59.158 70.7429 59.158C70.9959 59.2212 71.1224 59.3477 71.1224 59.5375Z",
    fill: "url(#paint72_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 59.5375C73.9701 59.7272 73.7803 59.917 73.5906 59.917C73.4008 59.917 73.2111 59.7272 73.2111 59.5375C73.2111 59.3477 73.4008 59.158 73.5906 59.158C73.7803 59.2212 73.9701 59.3477 73.9701 59.5375Z",
    fill: "url(#paint73_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M76.3076 59.2798C76.3076 59.4696 76.3077 59.7226 76.2444 59.9123C76.1812 59.9123 76.1179 59.9756 76.1179 59.9756C75.9281 59.9756 75.7384 59.7858 75.7384 59.5961C75.7384 59.4063 75.8649 59.2166 76.1179 59.2166C76.1811 59.2166 76.2444 59.2166 76.3076 59.2798Z",
    fill: "url(#paint74_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.923 61.4332C48.923 61.5597 48.8598 61.6862 48.7965 61.7494C48.7333 61.5597 48.7333 61.3067 48.67 61.1169C48.7965 61.1169 48.923 61.3067 48.923 61.4332Z",
    fill: "url(#paint75_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 61.432C51.5794 61.6217 51.3897 61.8115 51.1999 61.8115C51.0102 61.8115 50.8204 61.6217 50.8204 61.432C50.8204 61.2422 51.0102 61.0525 51.1999 61.0525C51.3897 61.1157 51.5794 61.2422 51.5794 61.432Z",
    fill: "url(#paint76_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 61.432C54.3607 61.6217 54.1709 61.8115 53.9812 61.8115C53.7914 61.8115 53.6017 61.6217 53.6017 61.432C53.6017 61.2422 53.7282 61.0525 53.9812 61.0525C54.2342 61.0525 54.3607 61.2422 54.3607 61.432Z",
    fill: "url(#paint77_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 61.432C57.1439 61.6217 56.9541 61.8115 56.7644 61.8115C56.5746 61.8115 56.3849 61.6217 56.3849 61.432C56.3849 61.2422 56.5746 61.0525 56.7644 61.0525C57.0174 61.1157 57.1439 61.2422 57.1439 61.432Z",
    fill: "url(#paint78_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 61.432C59.9271 61.6217 59.8006 61.8115 59.5476 61.8115C59.3578 61.8115 59.1681 61.6217 59.1681 61.432C59.1681 61.2422 59.2946 61.0525 59.5476 61.0525C59.8006 61.1157 59.9271 61.2422 59.9271 61.432Z",
    fill: "url(#paint79_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 61.432C62.7728 61.6217 62.583 61.8115 62.3933 61.8115C62.2035 61.8115 62.0138 61.6217 62.0138 61.432C62.0138 61.2422 62.2035 61.0525 62.3933 61.0525C62.583 61.1157 62.7728 61.2422 62.7728 61.432Z",
    fill: "url(#paint80_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 61.432C65.556 61.6217 65.4295 61.8115 65.1765 61.8115C64.9867 61.8115 64.797 61.6217 64.797 61.432C64.797 61.2422 64.9235 61.0525 65.1765 61.0525C65.3662 61.1157 65.556 61.2422 65.556 61.432Z",
    fill: "url(#paint81_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 61.432C68.3411 61.6217 68.1514 61.8115 67.9617 61.8115C67.7719 61.8115 67.5822 61.6217 67.5822 61.432C67.5822 61.2422 67.7719 61.0525 67.9617 61.0525C68.2147 61.1157 68.3411 61.2422 68.3411 61.432Z",
    fill: "url(#paint82_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 61.432C71.1224 61.6217 70.9959 61.8115 70.7429 61.8115C70.5531 61.8115 70.3634 61.6217 70.3634 61.432C70.3634 61.2422 70.4899 61.0525 70.7429 61.0525C70.9959 61.1157 71.1224 61.2422 71.1224 61.432Z",
    fill: "url(#paint83_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 61.432C73.9701 61.6217 73.7803 61.8115 73.5906 61.8115C73.4008 61.8115 73.2111 61.6217 73.2111 61.432C73.2111 61.2422 73.4008 61.0525 73.5906 61.0525C73.7803 61.1157 73.9701 61.2422 73.9701 61.432Z",
    fill: "url(#paint84_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M76.1198 61.1169C76.0565 61.3699 76.0565 61.5597 75.9933 61.8127C75.8668 61.7494 75.8035 61.6229 75.8035 61.4964C75.7403 61.2434 75.93 61.1169 76.1198 61.1169Z",
    fill: "url(#paint85_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 63.3304C51.5794 63.5202 51.3897 63.7099 51.1999 63.7099C51.0102 63.7099 50.8204 63.5834 50.8204 63.3304C50.8204 63.1407 51.0102 62.9509 51.1999 62.9509C51.3897 62.9509 51.5794 63.1407 51.5794 63.3304Z",
    fill: "url(#paint86_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 63.3304C54.3607 63.5202 54.1709 63.7099 53.9812 63.7099C53.7914 63.7099 53.6017 63.5834 53.6017 63.3304C53.6017 63.1407 53.7282 62.9509 53.9812 62.9509C54.2342 62.9509 54.3607 63.1407 54.3607 63.3304Z",
    fill: "url(#paint87_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 63.3304C57.1439 63.5202 56.9541 63.7099 56.7644 63.7099C56.5746 63.7099 56.3849 63.5834 56.3849 63.3304C56.3849 63.1407 56.5746 62.9509 56.7644 62.9509C57.0174 62.9509 57.1439 63.1407 57.1439 63.3304Z",
    fill: "url(#paint88_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 63.3304C59.9271 63.5202 59.8006 63.7099 59.5476 63.7099C59.3578 63.7099 59.1681 63.5834 59.1681 63.3304C59.1681 63.1407 59.2946 62.9509 59.5476 62.9509C59.8006 62.9509 59.9271 63.1407 59.9271 63.3304Z",
    fill: "url(#paint89_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 63.3304C62.7728 63.5202 62.583 63.7099 62.3933 63.7099C62.2035 63.7099 62.0138 63.5834 62.0138 63.3304C62.0138 63.1407 62.2035 62.9509 62.3933 62.9509C62.583 62.9509 62.7728 63.1407 62.7728 63.3304Z",
    fill: "url(#paint90_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 63.3304C65.556 63.5202 65.4295 63.7099 65.1765 63.7099C64.9867 63.7099 64.797 63.5834 64.797 63.3304C64.797 63.1407 64.9235 62.9509 65.1765 62.9509C65.3662 62.9509 65.556 63.1407 65.556 63.3304Z",
    fill: "url(#paint91_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 63.3304C68.3411 63.5202 68.1514 63.7099 67.9617 63.7099C67.7719 63.7099 67.5822 63.5834 67.5822 63.3304C67.5822 63.1407 67.7719 62.9509 67.9617 62.9509C68.2147 62.9509 68.3411 63.1407 68.3411 63.3304Z",
    fill: "url(#paint92_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 63.3304C71.1224 63.5202 70.9959 63.7099 70.7429 63.7099C70.5531 63.7099 70.3634 63.5834 70.3634 63.3304C70.3634 63.1407 70.4899 62.9509 70.7429 62.9509C70.9959 62.9509 71.1224 63.1407 71.1224 63.3304Z",
    fill: "url(#paint93_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 63.3304C73.9701 63.5202 73.7803 63.7099 73.5906 63.7099C73.4008 63.7099 73.2111 63.5834 73.2111 63.3304C73.2111 63.1407 73.4008 62.9509 73.5906 62.9509C73.7803 62.9509 73.9701 63.1407 73.9701 63.3304Z",
    fill: "url(#paint94_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 65.225C51.5794 65.4147 51.3897 65.6045 51.1999 65.6045C51.0102 65.6045 50.8204 65.4147 50.8204 65.225C50.8204 65.0352 51.0102 64.8455 51.1999 64.8455C51.3897 64.8455 51.5794 65.0352 51.5794 65.225Z",
    fill: "url(#paint95_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 65.225C54.3607 65.4147 54.1709 65.6045 53.9812 65.6045C53.7914 65.6045 53.6017 65.4147 53.6017 65.225C53.6017 65.0352 53.7282 64.8455 53.9812 64.8455C54.2342 64.8455 54.3607 65.0352 54.3607 65.225Z",
    fill: "url(#paint96_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 65.225C57.1439 65.4147 56.9541 65.6045 56.7644 65.6045C56.5746 65.6045 56.3849 65.4147 56.3849 65.225C56.3849 65.0352 56.5746 64.8455 56.7644 64.8455C57.0174 64.8455 57.1439 65.0352 57.1439 65.225Z",
    fill: "url(#paint97_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 65.225C59.9271 65.4147 59.8006 65.6045 59.5476 65.6045C59.3578 65.6045 59.1681 65.4147 59.1681 65.225C59.1681 65.0352 59.2946 64.8455 59.5476 64.8455C59.8006 64.8455 59.9271 65.0352 59.9271 65.225Z",
    fill: "url(#paint98_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 65.225C62.7728 65.4147 62.583 65.6045 62.3933 65.6045C62.2035 65.6045 62.0138 65.4147 62.0138 65.225C62.0138 65.0352 62.2035 64.8455 62.3933 64.8455C62.583 64.8455 62.7728 65.0352 62.7728 65.225Z",
    fill: "url(#paint99_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 65.225C65.556 65.4147 65.4295 65.6045 65.1765 65.6045C64.9867 65.6045 64.797 65.4147 64.797 65.225C64.797 65.0352 64.9235 64.8455 65.1765 64.8455C65.3662 64.8455 65.556 65.0352 65.556 65.225Z",
    fill: "url(#paint100_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 65.225C68.3411 65.4147 68.1514 65.6045 67.9617 65.6045C67.7719 65.6045 67.5822 65.4147 67.5822 65.225C67.5822 65.0352 67.7719 64.8455 67.9617 64.8455C68.2147 64.8455 68.3411 65.0352 68.3411 65.225Z",
    fill: "url(#paint101_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 65.225C71.1224 65.4147 70.9959 65.6045 70.7429 65.6045C70.5531 65.6045 70.3634 65.4147 70.3634 65.225C70.3634 65.0352 70.4899 64.8455 70.7429 64.8455C70.9959 64.8455 71.1224 65.0352 71.1224 65.225Z",
    fill: "url(#paint102_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 65.225C73.9701 65.4147 73.7803 65.6045 73.5906 65.6045C73.4008 65.6045 73.2111 65.4147 73.2111 65.225C73.2111 65.0352 73.4008 64.8455 73.5906 64.8455C73.7803 64.8455 73.9701 65.0352 73.9701 65.225Z",
    fill: "url(#paint103_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5799 67.0609C51.5799 67.1874 51.4534 67.3771 51.3269 67.3771C51.2004 67.1874 51.0739 66.9976 50.9474 66.8079C51.0106 66.7446 51.1371 66.6814 51.2636 66.6814C51.3901 66.7446 51.5799 66.8711 51.5799 67.0609Z",
    fill: "url(#paint104_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 67.0609C54.3607 67.2506 54.1709 67.4404 53.9812 67.4404C53.7914 67.4404 53.6017 67.2506 53.6017 67.0609C53.6017 66.8711 53.7282 66.6814 53.9812 66.6814C54.2342 66.6814 54.3607 66.8711 54.3607 67.0609Z",
    fill: "url(#paint105_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 67.0609C57.1439 67.2506 56.9541 67.4404 56.7644 67.4404C56.5746 67.4404 56.3849 67.2506 56.3849 67.0609C56.3849 66.8711 56.5746 66.6814 56.7644 66.6814C57.0174 66.7446 57.1439 66.8711 57.1439 67.0609Z",
    fill: "url(#paint106_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 67.0609C59.9271 67.2506 59.8006 67.4404 59.5476 67.4404C59.3578 67.4404 59.1681 67.2506 59.1681 67.0609C59.1681 66.8711 59.2946 66.6814 59.5476 66.6814C59.8006 66.7446 59.9271 66.8711 59.9271 67.0609Z",
    fill: "url(#paint107_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 67.0609C62.7728 67.2506 62.583 67.4404 62.3933 67.4404C62.2035 67.4404 62.0138 67.2506 62.0138 67.0609C62.0138 66.8711 62.2035 66.6814 62.3933 66.6814C62.583 66.7446 62.7728 66.8711 62.7728 67.0609Z",
    fill: "url(#paint108_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 67.0609C65.556 67.2506 65.4295 67.4404 65.1765 67.4404C64.9867 67.4404 64.797 67.2506 64.797 67.0609C64.797 66.8711 64.9235 66.6814 65.1765 66.6814C65.3662 66.7446 65.556 66.8711 65.556 67.0609Z",
    fill: "url(#paint109_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 67.0609C68.3411 67.2506 68.1514 67.4404 67.9617 67.4404C67.7719 67.4404 67.5822 67.2506 67.5822 67.0609C67.5822 66.8711 67.7719 66.6814 67.9617 66.6814C68.2147 66.7446 68.3411 66.8711 68.3411 67.0609Z",
    fill: "url(#paint110_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 67.0609C71.1224 67.2506 70.9959 67.4404 70.7429 67.4404C70.5531 67.4404 70.3634 67.2506 70.3634 67.0609C70.3634 66.8711 70.4899 66.6814 70.7429 66.6814C70.9959 66.7446 71.1224 66.8711 71.1224 67.0609Z",
    fill: "url(#paint111_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9068 66.9344C73.7803 67.1241 73.6538 67.2506 73.5273 67.4404C73.3376 67.4404 73.2111 67.2506 73.2111 67.0609C73.2111 66.8711 73.4008 66.6814 73.5906 66.6814C73.7171 66.7446 73.8436 66.8079 73.9068 66.9344Z",
    fill: "url(#paint112_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 68.9593C54.3607 69.1491 54.1709 69.3388 53.9812 69.3388C53.7914 69.3388 53.6017 69.2123 53.6017 68.9593C53.6017 68.7696 53.7282 68.5798 53.9812 68.5798C54.2342 68.5798 54.3607 68.7696 54.3607 68.9593Z",
    fill: "url(#paint113_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 68.9593C57.1439 69.1491 56.9541 69.3388 56.7644 69.3388C56.5746 69.3388 56.3849 69.2123 56.3849 68.9593C56.3849 68.7696 56.5746 68.5798 56.7644 68.5798C57.0174 68.5798 57.1439 68.7696 57.1439 68.9593Z",
    fill: "url(#paint114_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 68.9593C59.9271 69.1491 59.8006 69.3388 59.5476 69.3388C59.3578 69.3388 59.1681 69.2123 59.1681 68.9593C59.1681 68.7696 59.2946 68.5798 59.5476 68.5798C59.8006 68.5798 59.9271 68.7696 59.9271 68.9593Z",
    fill: "url(#paint115_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 68.9593C62.7728 69.1491 62.583 69.3388 62.3933 69.3388C62.2035 69.3388 62.0138 69.2123 62.0138 68.9593C62.0138 68.7696 62.2035 68.5798 62.3933 68.5798C62.583 68.5798 62.7728 68.7696 62.7728 68.9593Z",
    fill: "url(#paint116_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 68.9593C65.556 69.1491 65.4295 69.3388 65.1765 69.3388C64.9867 69.3388 64.797 69.2123 64.797 68.9593C64.797 68.7696 64.9235 68.5798 65.1765 68.5798C65.3662 68.5798 65.556 68.7696 65.556 68.9593Z",
    fill: "url(#paint117_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 68.9593C68.3411 69.1491 68.1514 69.3388 67.9617 69.3388C67.7719 69.3388 67.5822 69.2123 67.5822 68.9593C67.5822 68.7696 67.7719 68.5798 67.9617 68.5798C68.2147 68.5798 68.3411 68.7696 68.3411 68.9593Z",
    fill: "url(#paint118_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 68.9593C71.1224 69.1491 70.9959 69.3388 70.7429 69.3388C70.5531 69.3388 70.3634 69.2123 70.3634 68.9593C70.3634 68.7696 70.4899 68.5798 70.7429 68.5798C70.9959 68.5798 71.1224 68.7696 71.1224 68.9593Z",
    fill: "url(#paint119_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M56.8269 71.2334C57.0365 71.2334 57.2064 71.0635 57.2064 70.8539C57.2064 70.6443 57.0365 70.4744 56.8269 70.4744C56.6173 70.4744 56.4474 70.6443 56.4474 70.8539C56.4474 71.0635 56.6173 71.2334 56.8269 71.2334Z",
    fill: "url(#paint120_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 70.8539C59.9271 71.0436 59.8006 71.2334 59.5476 71.2334C59.3578 71.2334 59.1681 71.0436 59.1681 70.8539C59.1681 70.6641 59.2946 70.4744 59.5476 70.4744C59.8006 70.4744 59.9271 70.6641 59.9271 70.8539Z",
    fill: "url(#paint121_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3933 71.2334C62.6029 71.2334 62.7728 71.0635 62.7728 70.8539C62.7728 70.6443 62.6029 70.4744 62.3933 70.4744C62.1837 70.4744 62.0138 70.6443 62.0138 70.8539C62.0138 71.0635 62.1837 71.2334 62.3933 71.2334Z",
    fill: "url(#paint122_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 70.8539C65.556 71.0436 65.4295 71.2334 65.1765 71.2334C64.9867 71.2334 64.797 71.0436 64.797 70.8539C64.797 70.6641 64.9235 70.4744 65.1765 70.4744C65.3662 70.4744 65.556 70.6641 65.556 70.8539Z",
    fill: "url(#paint123_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.9617 71.2334C68.1712 71.2334 68.3411 71.0635 68.3411 70.8539C68.3411 70.6443 68.1712 70.4744 67.9617 70.4744C67.7521 70.4744 67.5822 70.6443 67.5822 70.8539C67.5822 71.0635 67.7521 71.2334 67.9617 71.2334Z",
    fill: "url(#paint124_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9287 72.5613C59.739 72.5613 59.5492 72.4981 59.3595 72.4348C59.4227 72.3716 59.486 72.3083 59.6125 72.3083C59.739 72.3716 59.8655 72.4349 59.9287 72.5613Z",
    fill: "url(#paint125_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.772 72.7503V72.8136C62.6455 72.8136 62.5823 72.8136 62.4558 72.8136C62.3293 72.8136 62.2028 72.8136 62.0763 72.8136V72.7503C62.0763 72.5606 62.266 72.3708 62.4558 72.3708C62.5823 72.3708 62.772 72.4973 62.772 72.7503Z",
    fill: "url(#paint126_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.4307 72.4973C65.2409 72.5606 65.0512 72.5606 64.8615 72.6238C64.9247 72.4974 65.0512 72.3708 65.1777 72.3708C65.3042 72.3708 65.3674 72.4341 65.4307 72.4973Z",
    fill: "url(#paint127_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9221 59.5328C48.9221 59.7226 48.7324 59.9123 48.5426 59.9123H48.4794C48.4794 59.6593 48.4161 59.4696 48.4161 59.2166C48.4794 59.2166 48.4794 59.2166 48.5426 59.2166C48.7324 59.2166 48.9221 59.3431 48.9221 59.5328Z",
    fill: "url(#paint128_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9221 57.6976C48.9221 57.8873 48.7324 58.0771 48.5426 58.0771C48.4794 58.0771 48.4794 58.0771 48.4161 58.0771C48.4161 57.8241 48.4161 57.6343 48.4794 57.3813H48.5426C48.7324 57.3181 48.9221 57.5078 48.9221 57.6976Z",
    fill: "url(#paint129_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.923 61.4332C48.923 61.5597 48.8598 61.6862 48.7965 61.7494C48.7333 61.5597 48.7333 61.3067 48.67 61.1169C48.7965 61.1169 48.923 61.3067 48.923 61.4332Z",
    fill: "url(#paint130_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.7965 55.5486C48.8598 55.6118 48.923 55.7383 48.923 55.8016C48.923 55.9913 48.7965 56.1178 48.67 56.1178C48.7333 55.9281 48.7333 55.7383 48.7965 55.5486Z",
    fill: "url(#paint131_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 65.225C51.5794 65.4147 51.3897 65.6045 51.1999 65.6045C51.0102 65.6045 50.8204 65.4147 50.8204 65.225C50.8204 65.0352 51.0102 64.8455 51.1999 64.8455C51.3897 64.8455 51.5794 65.0352 51.5794 65.225Z",
    fill: "url(#paint132_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 63.3304C51.5794 63.5202 51.3897 63.7099 51.1999 63.7099C51.0102 63.7099 50.8204 63.5834 50.8204 63.3304C50.8204 63.1407 51.0102 62.9509 51.1999 62.9509C51.3897 62.9509 51.5794 63.1407 51.5794 63.3304Z",
    fill: "url(#paint133_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 61.432C51.5794 61.6217 51.3897 61.8115 51.1999 61.8115C51.0102 61.8115 50.8204 61.6217 50.8204 61.432C50.8204 61.2422 51.0102 61.0525 51.1999 61.0525C51.3897 61.1157 51.5794 61.2422 51.5794 61.432Z",
    fill: "url(#paint134_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 59.5375C51.5794 59.7272 51.3897 59.917 51.1999 59.917C51.0102 59.917 50.8204 59.7272 50.8204 59.5375C50.8204 59.3477 51.0102 59.158 51.1999 59.158C51.3897 59.2212 51.5794 59.3477 51.5794 59.5375Z",
    fill: "url(#paint135_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 57.7015C51.5794 57.8913 51.3897 58.081 51.1999 58.081C51.0102 58.081 50.8204 57.9545 50.8204 57.7015C50.8204 57.5118 51.0102 57.322 51.1999 57.322C51.3897 57.322 51.5794 57.5118 51.5794 57.7015Z",
    fill: "url(#paint136_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 55.7972C51.5794 55.987 51.3897 56.1767 51.1999 56.1767C51.0102 56.1767 50.8204 55.987 50.8204 55.7972C50.8204 55.6075 51.0102 55.4177 51.1999 55.4177C51.3897 55.4177 51.5794 55.6075 51.5794 55.7972Z",
    fill: "url(#paint137_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 53.8988C51.5794 54.0885 51.3897 54.2783 51.1999 54.2783C51.0102 54.2783 50.8204 54.0885 50.8204 53.8988C50.8204 53.709 51.0102 53.5193 51.1999 53.5193C51.3897 53.5825 51.5794 53.709 51.5794 53.8988Z",
    fill: "url(#paint138_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5794 52.0726C51.5794 52.2624 51.3897 52.4521 51.1999 52.4521C51.0102 52.4521 50.8204 52.3256 50.8204 52.0726C50.8204 51.8829 51.0102 51.6931 51.1999 51.6931C51.3897 51.6931 51.5794 51.8196 51.5794 52.0726Z",
    fill: "url(#paint139_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5799 67.0609C51.5799 67.1874 51.4534 67.3771 51.3269 67.3771C51.2004 67.1874 51.0739 66.9976 50.9474 66.8079C51.0106 66.7446 51.1371 66.6814 51.2636 66.6814C51.3901 66.7446 51.5799 66.8711 51.5799 67.0609Z",
    fill: "url(#paint140_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M51.5799 50.1715C51.5799 50.3612 51.3901 50.551 51.2004 50.551C51.0739 50.551 51.0106 50.4877 50.9474 50.4245C51.0739 50.2347 51.2004 50.045 51.3901 49.8552C51.5166 49.9185 51.5799 50.045 51.5799 50.1715Z",
    fill: "url(#paint141_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 68.9593C54.3607 69.1491 54.1709 69.3388 53.9812 69.3388C53.7914 69.3388 53.6017 69.2123 53.6017 68.9593C53.6017 68.7696 53.7282 68.5798 53.9812 68.5798C54.2342 68.5798 54.3607 68.7696 54.3607 68.9593Z",
    fill: "url(#paint142_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 67.0609C54.3607 67.2506 54.1709 67.4404 53.9812 67.4404C53.7914 67.4404 53.6017 67.2506 53.6017 67.0609C53.6017 66.8711 53.7282 66.6814 53.9812 66.6814C54.2342 66.6814 54.3607 66.8711 54.3607 67.0609Z",
    fill: "url(#paint143_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 65.225C54.3607 65.4147 54.1709 65.6045 53.9812 65.6045C53.7914 65.6045 53.6017 65.4147 53.6017 65.225C53.6017 65.0352 53.7282 64.8455 53.9812 64.8455C54.2342 64.8455 54.3607 65.0352 54.3607 65.225Z",
    fill: "url(#paint144_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 63.3304C54.3607 63.5202 54.1709 63.7099 53.9812 63.7099C53.7914 63.7099 53.6017 63.5834 53.6017 63.3304C53.6017 63.1407 53.7282 62.9509 53.9812 62.9509C54.2342 62.9509 54.3607 63.1407 54.3607 63.3304Z",
    fill: "url(#paint145_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 61.432C54.3607 61.6217 54.1709 61.8115 53.9812 61.8115C53.7914 61.8115 53.6017 61.6217 53.6017 61.432C53.6017 61.2422 53.7282 61.0525 53.9812 61.0525C54.2342 61.0525 54.3607 61.2422 54.3607 61.432Z",
    fill: "url(#paint146_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 59.5375C54.3607 59.7272 54.1709 59.917 53.9812 59.917C53.7914 59.917 53.6017 59.7272 53.6017 59.5375C53.6017 59.3477 53.7282 59.158 53.9812 59.158C54.2342 59.158 54.3607 59.3477 54.3607 59.5375Z",
    fill: "url(#paint147_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 57.7015C54.3607 57.8913 54.1709 58.081 53.9812 58.081C53.7914 58.081 53.6017 57.9545 53.6017 57.7015C53.6017 57.5118 53.7282 57.322 53.9812 57.322C54.2342 57.322 54.3607 57.5118 54.3607 57.7015Z",
    fill: "url(#paint148_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 55.7972C54.3607 55.987 54.1709 56.1767 53.9812 56.1767C53.7914 56.1767 53.6017 55.987 53.6017 55.7972C53.6017 55.6075 53.7282 55.4177 53.9812 55.4177C54.2342 55.4177 54.3607 55.6075 54.3607 55.7972Z",
    fill: "url(#paint149_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 53.8988C54.3607 54.0885 54.1709 54.2783 53.9812 54.2783C53.7914 54.2783 53.6017 54.0885 53.6017 53.8988C53.6017 53.709 53.7282 53.5193 53.9812 53.5193C54.2342 53.5193 54.3607 53.709 54.3607 53.8988Z",
    fill: "url(#paint150_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 52.0726C54.3607 52.2624 54.1709 52.4521 53.9812 52.4521C53.7914 52.4521 53.6017 52.3256 53.6017 52.0726C53.6017 51.8829 53.7282 51.6931 53.9812 51.6931C54.2342 51.6931 54.3607 51.8196 54.3607 52.0726Z",
    fill: "url(#paint151_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 50.1742C54.3607 50.3639 54.1709 50.5537 53.9812 50.5537C53.7914 50.5537 53.6017 50.3639 53.6017 50.1742C53.6017 49.9844 53.7282 49.7947 53.9812 49.7947C54.2342 49.7947 54.3607 49.9844 54.3607 50.1742Z",
    fill: "url(#paint152_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M54.3607 48.274C54.3607 48.4638 54.1709 48.6535 53.9812 48.6535C53.7914 48.6535 53.6017 48.4638 53.6017 48.274C53.6017 48.0843 53.7282 47.8945 53.9812 47.8945C54.2342 47.8945 54.3607 48.0843 54.3607 48.274Z",
    fill: "url(#paint153_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M56.8269 71.2334C57.0365 71.2334 57.2064 71.0635 57.2064 70.8539C57.2064 70.6443 57.0365 70.4744 56.8269 70.4744C56.6173 70.4744 56.4474 70.6443 56.4474 70.8539C56.4474 71.0635 56.6173 71.2334 56.8269 71.2334Z",
    fill: "url(#paint154_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 68.9593C57.1439 69.1491 56.9541 69.3388 56.7644 69.3388C56.5746 69.3388 56.3849 69.2123 56.3849 68.9593C56.3849 68.7696 56.5746 68.5798 56.7644 68.5798C57.0174 68.5798 57.1439 68.7696 57.1439 68.9593Z",
    fill: "url(#paint155_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 67.0609C57.1439 67.2506 56.9541 67.4404 56.7644 67.4404C56.5746 67.4404 56.3849 67.2506 56.3849 67.0609C56.3849 66.8711 56.5746 66.6814 56.7644 66.6814C57.0174 66.7446 57.1439 66.8711 57.1439 67.0609Z",
    fill: "url(#paint156_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 65.225C57.1439 65.4147 56.9541 65.6045 56.7644 65.6045C56.5746 65.6045 56.3849 65.4147 56.3849 65.225C56.3849 65.0352 56.5746 64.8455 56.7644 64.8455C57.0174 64.8455 57.1439 65.0352 57.1439 65.225Z",
    fill: "url(#paint157_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 63.3304C57.1439 63.5202 56.9541 63.7099 56.7644 63.7099C56.5746 63.7099 56.3849 63.5834 56.3849 63.3304C56.3849 63.1407 56.5746 62.9509 56.7644 62.9509C57.0174 62.9509 57.1439 63.1407 57.1439 63.3304Z",
    fill: "url(#paint158_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 61.432C57.1439 61.6217 56.9541 61.8115 56.7644 61.8115C56.5746 61.8115 56.3849 61.6217 56.3849 61.432C56.3849 61.2422 56.5746 61.0525 56.7644 61.0525C57.0174 61.1157 57.1439 61.2422 57.1439 61.432Z",
    fill: "url(#paint159_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M56.8269 59.917C57.0365 59.917 57.2064 59.7471 57.2064 59.5375C57.2064 59.3279 57.0365 59.158 56.8269 59.158C56.6173 59.158 56.4474 59.3279 56.4474 59.5375C56.4474 59.7471 56.6173 59.917 56.8269 59.917Z",
    fill: "url(#paint160_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 57.7015C57.1439 57.8913 56.9541 58.081 56.7644 58.081C56.5746 58.081 56.3849 57.9545 56.3849 57.7015C56.3849 57.5118 56.5746 57.322 56.7644 57.322C57.0174 57.322 57.1439 57.5118 57.1439 57.7015Z",
    fill: "url(#paint161_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M56.8269 56.1767C57.0365 56.1767 57.2064 56.0068 57.2064 55.7972C57.2064 55.5876 57.0365 55.4177 56.8269 55.4177C56.6173 55.4177 56.4474 55.5876 56.4474 55.7972C56.4474 56.0068 56.6173 56.1767 56.8269 56.1767Z",
    fill: "url(#paint162_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 53.8988C57.1439 54.0885 56.9541 54.2783 56.7644 54.2783C56.5746 54.2783 56.3849 54.0885 56.3849 53.8988C56.3849 53.709 56.5746 53.5193 56.7644 53.5193C57.0174 53.5825 57.1439 53.709 57.1439 53.8988Z",
    fill: "url(#paint163_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 52.0726C57.1439 52.2624 56.9541 52.4521 56.7644 52.4521C56.5746 52.4521 56.3849 52.3256 56.3849 52.0726C56.3849 51.8829 56.5746 51.6931 56.7644 51.6931C57.0174 51.6931 57.1439 51.8196 57.1439 52.0726Z",
    fill: "url(#paint164_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M56.8269 50.5537C57.0365 50.5537 57.2064 50.3838 57.2064 50.1742C57.2064 49.9646 57.0365 49.7947 56.8269 49.7947C56.6173 49.7947 56.4474 49.9646 56.4474 50.1742C56.4474 50.3838 56.6173 50.5537 56.8269 50.5537Z",
    fill: "url(#paint165_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M56.8269 48.6533C57.0365 48.6533 57.2064 48.4834 57.2064 48.2738C57.2064 48.0642 57.0365 47.8943 56.8269 47.8943C56.6173 47.8943 56.4474 48.0642 56.4474 48.2738C56.4474 48.4834 56.6173 48.6533 56.8269 48.6533Z",
    fill: "url(#paint166_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M57.1439 46.3773C57.1439 46.5671 56.9541 46.7568 56.7644 46.7568C56.5746 46.7568 56.3849 46.6303 56.3849 46.3773C56.3849 46.1876 56.5746 45.9978 56.7644 45.9978C57.0174 46.0611 57.1439 46.1876 57.1439 46.3773Z",
    fill: "url(#paint167_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.6113 45.0477C59.4848 45.0477 59.3583 44.9844 59.295 44.9212C59.4848 44.8579 59.7378 44.8579 59.9275 44.7947C59.9275 44.9212 59.801 45.0477 59.6113 45.0477Z",
    fill: "url(#paint168_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 70.8539C59.9271 71.0436 59.8006 71.2334 59.5476 71.2334C59.3578 71.2334 59.1681 71.0436 59.1681 70.8539C59.1681 70.6641 59.2946 70.4744 59.5476 70.4744C59.8006 70.4744 59.9271 70.6641 59.9271 70.8539Z",
    fill: "url(#paint169_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 68.9593C59.9271 69.1491 59.8006 69.3388 59.5476 69.3388C59.3578 69.3388 59.1681 69.2123 59.1681 68.9593C59.1681 68.7696 59.2946 68.5798 59.5476 68.5798C59.8006 68.5798 59.9271 68.7696 59.9271 68.9593Z",
    fill: "url(#paint170_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 67.0609C59.9271 67.2506 59.8006 67.4404 59.5476 67.4404C59.3578 67.4404 59.1681 67.2506 59.1681 67.0609C59.1681 66.8711 59.2946 66.6814 59.5476 66.6814C59.8006 66.7446 59.9271 66.8711 59.9271 67.0609Z",
    fill: "url(#paint171_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 65.225C59.9271 65.4147 59.8006 65.6045 59.5476 65.6045C59.3578 65.6045 59.1681 65.4147 59.1681 65.225C59.1681 65.0352 59.2946 64.8455 59.5476 64.8455C59.8006 64.8455 59.9271 65.0352 59.9271 65.225Z",
    fill: "url(#paint172_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 63.3304C59.9271 63.5202 59.8006 63.7099 59.5476 63.7099C59.3578 63.7099 59.1681 63.5834 59.1681 63.3304C59.1681 63.1407 59.2946 62.9509 59.5476 62.9509C59.8006 62.9509 59.9271 63.1407 59.9271 63.3304Z",
    fill: "url(#paint173_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 61.432C59.9271 61.6217 59.8006 61.8115 59.5476 61.8115C59.3578 61.8115 59.1681 61.6217 59.1681 61.432C59.1681 61.2422 59.2946 61.0525 59.5476 61.0525C59.8006 61.1157 59.9271 61.2422 59.9271 61.432Z",
    fill: "url(#paint174_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 59.5375C59.9271 59.7272 59.8006 59.917 59.5476 59.917C59.3578 59.917 59.1681 59.7272 59.1681 59.5375C59.1681 59.3477 59.2946 59.158 59.5476 59.158C59.8006 59.2212 59.9271 59.3477 59.9271 59.5375Z",
    fill: "url(#paint175_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 57.7015C59.9271 57.8913 59.8006 58.081 59.5476 58.081C59.3578 58.081 59.1681 57.9545 59.1681 57.7015C59.1681 57.5118 59.2946 57.322 59.5476 57.322C59.8006 57.322 59.9271 57.5118 59.9271 57.7015Z",
    fill: "url(#paint176_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 55.7972C59.9271 55.987 59.8006 56.1767 59.5476 56.1767C59.3578 56.1767 59.1681 55.987 59.1681 55.7972C59.1681 55.6075 59.2946 55.4177 59.5476 55.4177C59.8006 55.4177 59.9271 55.6075 59.9271 55.7972Z",
    fill: "url(#paint177_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 53.8988C59.9271 54.0885 59.8006 54.2783 59.5476 54.2783C59.3578 54.2783 59.1681 54.0885 59.1681 53.8988C59.1681 53.709 59.2946 53.5193 59.5476 53.5193C59.8006 53.5825 59.9271 53.709 59.9271 53.8988Z",
    fill: "url(#paint178_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 52.0726C59.9271 52.2624 59.8006 52.4521 59.5476 52.4521C59.3578 52.4521 59.1681 52.3256 59.1681 52.0726C59.1681 51.8829 59.2946 51.6931 59.5476 51.6931C59.8006 51.6931 59.9271 51.8196 59.9271 52.0726Z",
    fill: "url(#paint179_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 50.1742C59.9271 50.3639 59.8006 50.5537 59.5476 50.5537C59.3578 50.5537 59.1681 50.3639 59.1681 50.1742C59.1681 49.9844 59.2946 49.7947 59.5476 49.7947C59.8006 49.7947 59.9271 49.9844 59.9271 50.1742Z",
    fill: "url(#paint180_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 48.2738C59.9271 48.4635 59.8006 48.6533 59.5476 48.6533C59.3578 48.6533 59.1681 48.4635 59.1681 48.2738C59.1681 48.084 59.2946 47.8943 59.5476 47.8943C59.8006 47.8943 59.9271 48.084 59.9271 48.2738Z",
    fill: "url(#paint181_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9271 46.3773C59.9271 46.5671 59.8006 46.7568 59.5476 46.7568C59.3578 46.7568 59.1681 46.6303 59.1681 46.3773C59.1681 46.1876 59.2946 45.9978 59.5476 45.9978C59.8006 46.0611 59.9271 46.1876 59.9271 46.3773Z",
    fill: "url(#paint182_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M59.9287 72.5613C59.739 72.5613 59.5492 72.4981 59.3595 72.4348C59.4227 72.3716 59.486 72.3083 59.6125 72.3083C59.739 72.3716 59.8655 72.4349 59.9287 72.5613Z",
    fill: "url(#paint183_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3933 71.2334C62.6029 71.2334 62.7728 71.0635 62.7728 70.8539C62.7728 70.6443 62.6029 70.4744 62.3933 70.4744C62.1837 70.4744 62.0138 70.6443 62.0138 70.8539C62.0138 71.0635 62.1837 71.2334 62.3933 71.2334Z",
    fill: "url(#paint184_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 68.9593C62.7728 69.1491 62.583 69.3388 62.3933 69.3388C62.2035 69.3388 62.0138 69.2123 62.0138 68.9593C62.0138 68.7696 62.2035 68.5798 62.3933 68.5798C62.583 68.5798 62.7728 68.7696 62.7728 68.9593Z",
    fill: "url(#paint185_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 67.0609C62.7728 67.2506 62.583 67.4404 62.3933 67.4404C62.2035 67.4404 62.0138 67.2506 62.0138 67.0609C62.0138 66.8711 62.2035 66.6814 62.3933 66.6814C62.583 66.7446 62.7728 66.8711 62.7728 67.0609Z",
    fill: "url(#paint186_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 65.225C62.7728 65.4147 62.583 65.6045 62.3933 65.6045C62.2035 65.6045 62.0138 65.4147 62.0138 65.225C62.0138 65.0352 62.2035 64.8455 62.3933 64.8455C62.583 64.8455 62.7728 65.0352 62.7728 65.225Z",
    fill: "url(#paint187_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 63.3304C62.7728 63.5202 62.583 63.7099 62.3933 63.7099C62.2035 63.7099 62.0138 63.5834 62.0138 63.3304C62.0138 63.1407 62.2035 62.9509 62.3933 62.9509C62.583 62.9509 62.7728 63.1407 62.7728 63.3304Z",
    fill: "url(#paint188_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 61.432C62.7728 61.6217 62.583 61.8115 62.3933 61.8115C62.2035 61.8115 62.0138 61.6217 62.0138 61.432C62.0138 61.2422 62.2035 61.0525 62.3933 61.0525C62.583 61.1157 62.7728 61.2422 62.7728 61.432Z",
    fill: "url(#paint189_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3933 59.917C62.6029 59.917 62.7728 59.7471 62.7728 59.5375C62.7728 59.3279 62.6029 59.158 62.3933 59.158C62.1837 59.158 62.0138 59.3279 62.0138 59.5375C62.0138 59.7471 62.1837 59.917 62.3933 59.917Z",
    fill: "url(#paint190_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 57.7015C62.7728 57.8913 62.583 58.081 62.3933 58.081C62.2035 58.081 62.0138 57.9545 62.0138 57.7015C62.0138 57.5118 62.2035 57.322 62.3933 57.322C62.583 57.322 62.7728 57.5118 62.7728 57.7015Z",
    fill: "url(#paint191_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3933 56.1767C62.6029 56.1767 62.7728 56.0068 62.7728 55.7972C62.7728 55.5876 62.6029 55.4177 62.3933 55.4177C62.1837 55.4177 62.0138 55.5876 62.0138 55.7972C62.0138 56.0068 62.1837 56.1767 62.3933 56.1767Z",
    fill: "url(#paint192_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 53.8988C62.7728 54.0885 62.583 54.2783 62.3933 54.2783C62.2035 54.2783 62.0138 54.0885 62.0138 53.8988C62.0138 53.709 62.2035 53.5193 62.3933 53.5193C62.583 53.5825 62.7728 53.709 62.7728 53.8988Z",
    fill: "url(#paint193_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 52.0726C62.7728 52.2624 62.583 52.4521 62.3933 52.4521C62.2035 52.4521 62.0138 52.3256 62.0138 52.0726C62.0138 51.8829 62.2035 51.6931 62.3933 51.6931C62.583 51.6931 62.7728 51.8196 62.7728 52.0726Z",
    fill: "url(#paint194_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3933 50.5537C62.6029 50.5537 62.7728 50.3838 62.7728 50.1742C62.7728 49.9646 62.6029 49.7947 62.3933 49.7947C62.1837 49.7947 62.0138 49.9646 62.0138 50.1742C62.0138 50.3838 62.1837 50.5537 62.3933 50.5537Z",
    fill: "url(#paint195_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.3933 48.6533C62.6029 48.6533 62.7728 48.4834 62.7728 48.2738C62.7728 48.0642 62.6029 47.8943 62.3933 47.8943C62.1837 47.8943 62.0138 48.0642 62.0138 48.2738C62.0138 48.4834 62.1837 48.6533 62.3933 48.6533Z",
    fill: "url(#paint196_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7728 46.3773C62.7728 46.5671 62.583 46.7568 62.3933 46.7568C62.2035 46.7568 62.0138 46.6303 62.0138 46.3773C62.0138 46.1876 62.2035 45.9978 62.3933 45.9978C62.583 46.0611 62.7728 46.1876 62.7728 46.3773Z",
    fill: "url(#paint197_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.7103 44.5427C62.7103 44.606 62.7103 44.606 62.7103 44.6692C62.7103 44.859 62.5205 45.0487 62.3308 45.0487C62.141 45.0487 61.9513 44.859 61.9513 44.6692C61.9513 44.606 61.9513 44.5427 61.9513 44.5427C62.0778 44.5427 62.2043 44.5427 62.3308 44.5427C62.5205 44.5427 62.647 44.5427 62.7103 44.5427Z",
    fill: "url(#paint198_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M62.772 72.7503V72.8136C62.6455 72.8136 62.5823 72.8136 62.4558 72.8136C62.3293 72.8136 62.2028 72.8136 62.0763 72.8136V72.7503C62.0763 72.5606 62.266 72.3708 62.4558 72.3708C62.5823 72.3708 62.772 72.4973 62.772 72.7503Z",
    fill: "url(#paint199_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 70.8539C65.556 71.0436 65.4295 71.2334 65.1765 71.2334C64.9867 71.2334 64.797 71.0436 64.797 70.8539C64.797 70.6641 64.9235 70.4744 65.1765 70.4744C65.3662 70.4744 65.556 70.6641 65.556 70.8539Z",
    fill: "url(#paint200_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 68.9593C65.556 69.1491 65.4295 69.3388 65.1765 69.3388C64.9867 69.3388 64.797 69.2123 64.797 68.9593C64.797 68.7696 64.9235 68.5798 65.1765 68.5798C65.3662 68.5798 65.556 68.7696 65.556 68.9593Z",
    fill: "url(#paint201_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 67.0609C65.556 67.2506 65.4295 67.4404 65.1765 67.4404C64.9867 67.4404 64.797 67.2506 64.797 67.0609C64.797 66.8711 64.9235 66.6814 65.1765 66.6814C65.3662 66.7446 65.556 66.8711 65.556 67.0609Z",
    fill: "url(#paint202_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 65.225C65.556 65.4147 65.4295 65.6045 65.1765 65.6045C64.9867 65.6045 64.797 65.4147 64.797 65.225C64.797 65.0352 64.9235 64.8455 65.1765 64.8455C65.3662 64.8455 65.556 65.0352 65.556 65.225Z",
    fill: "url(#paint203_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 63.3304C65.556 63.5202 65.4295 63.7099 65.1765 63.7099C64.9867 63.7099 64.797 63.5834 64.797 63.3304C64.797 63.1407 64.9235 62.9509 65.1765 62.9509C65.3662 62.9509 65.556 63.1407 65.556 63.3304Z",
    fill: "url(#paint204_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 61.432C65.556 61.6217 65.4295 61.8115 65.1765 61.8115C64.9867 61.8115 64.797 61.6217 64.797 61.432C64.797 61.2422 64.9235 61.0525 65.1765 61.0525C65.3662 61.1157 65.556 61.2422 65.556 61.432Z",
    fill: "url(#paint205_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 59.5375C65.556 59.7272 65.4295 59.917 65.1765 59.917C64.9867 59.917 64.797 59.7272 64.797 59.5375C64.797 59.3477 64.9235 59.158 65.1765 59.158C65.3662 59.2212 65.556 59.3477 65.556 59.5375Z",
    fill: "url(#paint206_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 57.7015C65.556 57.8913 65.4295 58.081 65.1765 58.081C64.9867 58.081 64.797 57.9545 64.797 57.7015C64.797 57.5118 64.9235 57.322 65.1765 57.322C65.3662 57.322 65.556 57.5118 65.556 57.7015Z",
    fill: "url(#paint207_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.5562 55.7972C65.5562 55.987 65.4297 56.1767 65.1767 56.1767C64.987 56.1767 64.7972 55.987 64.7972 55.7972C64.7972 55.6075 64.9237 55.4177 65.1767 55.4177C65.3665 55.4177 65.5562 55.6075 65.5562 55.7972Z",
    fill: "url(#paint208_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 53.8988C65.556 54.0885 65.4295 54.2783 65.1765 54.2783C64.9867 54.2783 64.797 54.0885 64.797 53.8988C64.797 53.709 64.9235 53.5193 65.1765 53.5193C65.3662 53.5825 65.556 53.709 65.556 53.8988Z",
    fill: "url(#paint209_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 52.0726C65.556 52.2624 65.4295 52.4521 65.1765 52.4521C64.9867 52.4521 64.797 52.3256 64.797 52.0726C64.797 51.8829 64.9235 51.6931 65.1765 51.6931C65.3662 51.6931 65.556 51.8196 65.556 52.0726Z",
    fill: "url(#paint210_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 50.1742C65.556 50.3639 65.4295 50.5537 65.1765 50.5537C64.9867 50.5537 64.797 50.3639 64.797 50.1742C64.797 49.9844 64.9235 49.7947 65.1765 49.7947C65.3662 49.7947 65.556 49.9844 65.556 50.1742Z",
    fill: "url(#paint211_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.5562 48.274C65.5562 48.4638 65.4297 48.6535 65.1767 48.6535C64.987 48.6535 64.7972 48.4638 64.7972 48.274C64.7972 48.0843 64.9237 47.8945 65.1767 47.8945C65.3665 47.8945 65.5562 48.0843 65.5562 48.274Z",
    fill: "url(#paint212_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.556 46.3773C65.556 46.5671 65.4295 46.7568 65.1765 46.7568C64.9867 46.7568 64.797 46.6303 64.797 46.3773C64.797 46.1876 64.9235 45.9978 65.1765 45.9978C65.3662 46.0611 65.556 46.1876 65.556 46.3773Z",
    fill: "url(#paint213_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M65.1777 72.3708C65.3042 72.3708 65.3674 72.4341 65.4307 72.4973C65.2409 72.5606 65.0512 72.5606 64.8615 72.6238C64.9247 72.4341 65.0512 72.3708 65.1777 72.3708Z",
    fill: "url(#paint214_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M64.8615 44.7341C65.0512 44.7974 65.3042 44.7974 65.4939 44.8606C65.4307 44.9871 65.3042 45.0504 65.1777 45.0504C64.9879 45.0504 64.8615 44.9239 64.8615 44.7341Z",
    fill: "url(#paint215_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.9617 71.2334C68.1712 71.2334 68.3411 71.0635 68.3411 70.8539C68.3411 70.6443 68.1712 70.4744 67.9617 70.4744C67.7521 70.4744 67.5822 70.6443 67.5822 70.8539C67.5822 71.0635 67.7521 71.2334 67.9617 71.2334Z",
    fill: "url(#paint216_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 68.9593C68.3411 69.1491 68.1514 69.3388 67.9617 69.3388C67.7719 69.3388 67.5822 69.2123 67.5822 68.9593C67.5822 68.7696 67.7719 68.5798 67.9617 68.5798C68.2147 68.5798 68.3411 68.7696 68.3411 68.9593Z",
    fill: "url(#paint217_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 67.0609C68.3411 67.2506 68.1514 67.4404 67.9617 67.4404C67.7719 67.4404 67.5822 67.2506 67.5822 67.0609C67.5822 66.8711 67.7719 66.6814 67.9617 66.6814C68.2147 66.7446 68.3411 66.8711 68.3411 67.0609Z",
    fill: "url(#paint218_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 65.225C68.3411 65.4147 68.1514 65.6045 67.9617 65.6045C67.7719 65.6045 67.5822 65.4147 67.5822 65.225C67.5822 65.0352 67.7719 64.8455 67.9617 64.8455C68.2147 64.8455 68.3411 65.0352 68.3411 65.225Z",
    fill: "url(#paint219_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 63.3304C68.3411 63.5202 68.1514 63.7099 67.9617 63.7099C67.7719 63.7099 67.5822 63.5834 67.5822 63.3304C67.5822 63.1407 67.7719 62.9509 67.9617 62.9509C68.2147 62.9509 68.3411 63.1407 68.3411 63.3304Z",
    fill: "url(#paint220_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 61.432C68.3411 61.6217 68.1514 61.8115 67.9617 61.8115C67.7719 61.8115 67.5822 61.6217 67.5822 61.432C67.5822 61.2422 67.7719 61.0525 67.9617 61.0525C68.2147 61.1157 68.3411 61.2422 68.3411 61.432Z",
    fill: "url(#paint221_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.9617 59.917C68.1712 59.917 68.3411 59.7471 68.3411 59.5375C68.3411 59.3279 68.1712 59.158 67.9617 59.158C67.7521 59.158 67.5822 59.3279 67.5822 59.5375C67.5822 59.7471 67.7521 59.917 67.9617 59.917Z",
    fill: "url(#paint222_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 57.7015C68.3411 57.8913 68.1514 58.081 67.9617 58.081C67.7719 58.081 67.5822 57.9545 67.5822 57.7015C67.5822 57.5118 67.7719 57.322 67.9617 57.322C68.2147 57.322 68.3411 57.5118 68.3411 57.7015Z",
    fill: "url(#paint223_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.9617 56.1767C68.1712 56.1767 68.3411 56.0068 68.3411 55.7972C68.3411 55.5876 68.1712 55.4177 67.9617 55.4177C67.7521 55.4177 67.5822 55.5876 67.5822 55.7972C67.5822 56.0068 67.7521 56.1767 67.9617 56.1767Z",
    fill: "url(#paint224_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 53.8988C68.3411 54.0885 68.1514 54.2783 67.9617 54.2783C67.7719 54.2783 67.5822 54.0885 67.5822 53.8988C67.5822 53.709 67.7719 53.5193 67.9617 53.5193C68.2147 53.5825 68.3411 53.709 68.3411 53.8988Z",
    fill: "url(#paint225_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 52.0726C68.3411 52.2624 68.1514 52.4521 67.9617 52.4521C67.7719 52.4521 67.5822 52.3256 67.5822 52.0726C67.5822 51.8829 67.7719 51.6931 67.9617 51.6931C68.2147 51.6931 68.3411 51.8196 68.3411 52.0726Z",
    fill: "url(#paint226_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.9617 50.5537C68.1712 50.5537 68.3411 50.3838 68.3411 50.1742C68.3411 49.9646 68.1712 49.7947 67.9617 49.7947C67.7521 49.7947 67.5822 49.9646 67.5822 50.1742C67.5822 50.3838 67.7521 50.5537 67.9617 50.5537Z",
    fill: "url(#paint227_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M67.9617 48.6533C68.1712 48.6533 68.3411 48.4834 68.3411 48.2738C68.3411 48.0642 68.1712 47.8943 67.9617 47.8943C67.7521 47.8943 67.5822 48.0642 67.5822 48.2738C67.5822 48.4834 67.7521 48.6533 67.9617 48.6533Z",
    fill: "url(#paint228_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M68.3411 46.3773C68.3411 46.5671 68.1514 46.7568 67.9617 46.7568C67.7719 46.7568 67.5822 46.6303 67.5822 46.3773C67.5822 46.1876 67.7719 45.9978 67.9617 45.9978C68.2147 46.0611 68.3411 46.1876 68.3411 46.3773Z",
    fill: "url(#paint229_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 68.9593C71.1224 69.1491 70.9959 69.3388 70.7429 69.3388C70.5531 69.3388 70.3634 69.2123 70.3634 68.9593C70.3634 68.7696 70.4899 68.5798 70.7429 68.5798C70.9959 68.5798 71.1224 68.7696 71.1224 68.9593Z",
    fill: "url(#paint230_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 67.0609C71.1224 67.2506 70.9959 67.4404 70.7429 67.4404C70.5531 67.4404 70.3634 67.2506 70.3634 67.0609C70.3634 66.8711 70.4899 66.6814 70.7429 66.6814C70.9959 66.7446 71.1224 66.8711 71.1224 67.0609Z",
    fill: "url(#paint231_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 65.225C71.1224 65.4147 70.9959 65.6045 70.7429 65.6045C70.5531 65.6045 70.3634 65.4147 70.3634 65.225C70.3634 65.0352 70.4899 64.8455 70.7429 64.8455C70.9959 64.8455 71.1224 65.0352 71.1224 65.225Z",
    fill: "url(#paint232_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 63.3304C71.1224 63.5202 70.9959 63.7099 70.7429 63.7099C70.5531 63.7099 70.3634 63.5834 70.3634 63.3304C70.3634 63.1407 70.4899 62.9509 70.7429 62.9509C70.9959 62.9509 71.1224 63.1407 71.1224 63.3304Z",
    fill: "url(#paint233_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 61.432C71.1224 61.6217 70.9959 61.8115 70.7429 61.8115C70.5531 61.8115 70.3634 61.6217 70.3634 61.432C70.3634 61.2422 70.4899 61.0525 70.7429 61.0525C70.9959 61.1157 71.1224 61.2422 71.1224 61.432Z",
    fill: "url(#paint234_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 59.5375C71.1224 59.7272 70.9959 59.917 70.7429 59.917C70.5531 59.917 70.3634 59.7272 70.3634 59.5375C70.3634 59.3477 70.4899 59.158 70.7429 59.158C70.9959 59.2212 71.1224 59.3477 71.1224 59.5375Z",
    fill: "url(#paint235_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 57.7015C71.1224 57.8913 70.9959 58.081 70.7429 58.081C70.5531 58.081 70.3634 57.9545 70.3634 57.7015C70.3634 57.5118 70.4899 57.322 70.7429 57.322C70.9959 57.322 71.1224 57.5118 71.1224 57.7015Z",
    fill: "url(#paint236_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 55.7972C71.1224 55.987 70.9959 56.1767 70.7429 56.1767C70.5531 56.1767 70.3634 55.987 70.3634 55.7972C70.3634 55.6075 70.4899 55.4177 70.7429 55.4177C70.9959 55.4177 71.1224 55.6075 71.1224 55.7972Z",
    fill: "url(#paint237_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 53.8988C71.1224 54.0885 70.9959 54.2783 70.7429 54.2783C70.5531 54.2783 70.3634 54.0885 70.3634 53.8988C70.3634 53.709 70.4899 53.5193 70.7429 53.5193C70.9959 53.5825 71.1224 53.709 71.1224 53.8988Z",
    fill: "url(#paint238_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 52.0726C71.1224 52.2624 70.9959 52.4521 70.7429 52.4521C70.5531 52.4521 70.3634 52.3256 70.3634 52.0726C70.3634 51.8829 70.4899 51.6931 70.7429 51.6931C70.9959 51.6931 71.1224 51.8196 71.1224 52.0726Z",
    fill: "url(#paint239_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 50.1742C71.1224 50.3639 70.9959 50.5537 70.7429 50.5537C70.5531 50.5537 70.3634 50.3639 70.3634 50.1742C70.3634 49.9844 70.4899 49.7947 70.7429 49.7947C70.9959 49.7947 71.1224 49.9844 71.1224 50.1742Z",
    fill: "url(#paint240_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M71.1224 48.2738C71.1224 48.4635 70.9959 48.6533 70.7429 48.6533C70.5531 48.6533 70.3634 48.4635 70.3634 48.2738C70.3634 48.084 70.4899 47.8943 70.7429 47.8943C70.9959 47.8943 71.1224 48.084 71.1224 48.2738Z",
    fill: "url(#paint241_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 65.225C73.9701 65.4147 73.7803 65.6045 73.5906 65.6045C73.4008 65.6045 73.2111 65.4147 73.2111 65.225C73.2111 65.0352 73.4008 64.8455 73.5906 64.8455C73.7803 64.8455 73.9701 65.0352 73.9701 65.225Z",
    fill: "url(#paint242_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 63.3304C73.9701 63.5202 73.7803 63.7099 73.5906 63.7099C73.4008 63.7099 73.2111 63.5834 73.2111 63.3304C73.2111 63.1407 73.4008 62.9509 73.5906 62.9509C73.7803 62.9509 73.9701 63.1407 73.9701 63.3304Z",
    fill: "url(#paint243_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 61.432C73.9701 61.6217 73.7803 61.8115 73.5906 61.8115C73.4008 61.8115 73.2111 61.6217 73.2111 61.432C73.2111 61.2422 73.4008 61.0525 73.5906 61.0525C73.7803 61.1157 73.9701 61.2422 73.9701 61.432Z",
    fill: "url(#paint244_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 59.5375C73.9701 59.7272 73.7803 59.917 73.5906 59.917C73.4008 59.917 73.2111 59.7272 73.2111 59.5375C73.2111 59.3477 73.4008 59.158 73.5906 59.158C73.7803 59.2212 73.9701 59.3477 73.9701 59.5375Z",
    fill: "url(#paint245_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 57.7015C73.9701 57.8913 73.7803 58.081 73.5906 58.081C73.4008 58.081 73.2111 57.9545 73.2111 57.7015C73.2111 57.5118 73.4008 57.322 73.5906 57.322C73.7803 57.322 73.9701 57.5118 73.9701 57.7015Z",
    fill: "url(#paint246_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 55.7972C73.9701 55.987 73.7803 56.1767 73.5906 56.1767C73.4008 56.1767 73.2111 55.987 73.2111 55.7972C73.2111 55.6075 73.4008 55.4177 73.5906 55.4177C73.7803 55.4177 73.9701 55.6075 73.9701 55.7972Z",
    fill: "url(#paint247_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 53.8988C73.9701 54.0885 73.7803 54.2783 73.5906 54.2783C73.4008 54.2783 73.2111 54.0885 73.2111 53.8988C73.2111 53.709 73.4008 53.5193 73.5906 53.5193C73.7803 53.5825 73.9701 53.709 73.9701 53.8988Z",
    fill: "url(#paint248_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9701 52.0726C73.9701 52.2624 73.7803 52.4521 73.5906 52.4521C73.4008 52.4521 73.2111 52.3256 73.2111 52.0726C73.2111 51.8829 73.4008 51.6931 73.5906 51.6931C73.7803 51.6931 73.9701 51.8196 73.9701 52.0726Z",
    fill: "url(#paint249_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.2111 50.1715C73.2111 49.9817 73.3376 49.8552 73.4641 49.8552C73.5906 50.045 73.7171 50.2347 73.8436 50.3612C73.7803 50.4877 73.6538 50.551 73.5273 50.551C73.4008 50.4877 73.2111 50.3612 73.2111 50.1715Z",
    fill: "url(#paint250_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M73.9068 66.9344C73.7803 67.1241 73.6538 67.2506 73.5273 67.4404C73.3376 67.4404 73.2111 67.2506 73.2111 67.0609C73.2111 66.8711 73.4008 66.6814 73.5906 66.6814C73.7171 66.7446 73.8436 66.8079 73.9068 66.9344Z",
    fill: "url(#paint251_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M75.7384 55.8004C75.7384 55.6739 75.8017 55.5474 75.9282 55.4841C75.9914 55.7371 76.0547 55.9269 76.0547 56.1799C75.8649 56.1799 75.7384 55.9901 75.7384 55.8004Z",
    fill: "url(#paint252_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M76.1198 61.1169C76.0565 61.3699 76.0565 61.5597 75.9933 61.8127C75.8668 61.7494 75.8035 61.6229 75.8035 61.4964C75.7403 61.2434 75.93 61.1169 76.1198 61.1169Z",
    fill: "url(#paint253_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M75.7384 57.7015C75.7384 57.5118 75.8649 57.322 76.1179 57.322C76.1811 57.322 76.2444 57.322 76.2444 57.322C76.2444 57.5118 76.3076 57.7648 76.3076 57.9545C76.2444 58.0178 76.1811 58.0178 76.1179 58.0178C75.9281 58.0178 75.7384 57.8913 75.7384 57.7015Z",
    fill: "url(#paint254_linear_2_963)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M76.3076 59.2798C76.3076 59.4696 76.3077 59.7226 76.2444 59.9123C76.1812 59.9123 76.1179 59.9756 76.1179 59.9756C75.9281 59.9756 75.7384 59.7858 75.7384 59.5961C75.7384 59.4063 75.8649 59.2166 76.1179 59.2166C76.1811 59.2166 76.2444 59.2166 76.3076 59.2798Z",
    fill: "url(#paint255_linear_2_963)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0463 36.7829C24.101 34.1085 73.2982 34.1085 72.3479 36.7829H75.8697C76.6829 34.1378 77.1188 31.3312 77.1188 28.4216C77.1187 12.723 64.3981 0 48.6995 0C33.0009 0 20.2754 12.723 20.2754 28.4216C20.2754 31.3311 20.7161 34.1378 21.5245 36.7829H25.0463Z",
    fill: "url(#paint256_linear_2_963)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8555 58.0031L48.4871 37.0391L63.1161 58.0031H33.8555Z",
    fill: "#43A7D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5167 41.9785H23.3594L30.0453 52.01H66.8257L73.5167 41.9785Z",
    fill: "#52CBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7966 36.7538C88.7966 41.3678 85.0544 45.1125 80.4354 45.1125H16.9011C12.2871 45.1125 8.54492 41.3678 8.54492 36.7538V36.7538C8.54492 32.1348 12.2871 28.3926 16.9011 28.3926H80.4354C85.0544 28.3926 88.7966 32.1348 88.7966 36.7538V36.7538Z",
    fill: "url(#paint257_linear_2_963)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4627 36.8642C30.4627 37.785 29.7133 38.5344 28.7924 38.5344C27.8667 38.5344 27.1172 37.785 27.1172 36.8642C27.1172 35.9384 27.8666 35.1914 28.7924 35.1914C29.7133 35.1914 30.4627 35.9384 30.4627 36.8642Z",
    fill: "#434A54"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8377 36.8642C43.8377 37.785 43.0883 38.5344 42.1624 38.5344C41.2416 38.5344 40.4922 37.785 40.4922 36.8642C40.4922 35.9384 41.2416 35.1914 42.1624 35.1914C43.0883 35.1914 43.8377 35.9384 43.8377 36.8642Z",
    fill: "#434A54"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2135 36.8642C57.2135 37.785 56.469 38.5344 55.5433 38.5344C54.6224 38.5344 53.873 37.785 53.873 36.8642C53.873 35.9384 54.6224 35.1914 55.5433 35.1914C56.469 35.1914 57.2135 35.9384 57.2135 36.8642Z",
    fill: "#434A54"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5877 36.8642C70.5877 37.785 69.8383 38.5344 68.9174 38.5344C67.9917 38.5344 67.2422 37.785 67.2422 36.8642C67.2422 35.9384 67.9916 35.1914 68.9174 35.1914C69.8383 35.1914 70.5877 35.9384 70.5877 36.8642Z",
    fill: "#434A54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6733 6.60547C47.7476 6.60547 46.998 7.35485 46.998 8.27821C46.998 9.20158 47.7476 9.95096 48.6733 9.95096C53.6058 9.95096 58.2443 11.871 61.7318 15.3585C65.2193 18.846 67.1393 23.4847 67.1393 28.417H70.4848C70.4848 16.3723 60.718 6.60547 48.6733 6.60547Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 36.9629,
    y: 45.1406,
    width: 3.34549,
    height: 6.68848,
    fill: "#25789C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 46.9944,
    y: 45.1406,
    width: 3.34549,
    height: 6.68848,
    fill: "#25789C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 57.0275,
    y: 45.1406,
    width: 3.34549,
    height: 6.68848,
    fill: "#25789C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_963",
    x1: 59.3099,
    y1: 44.8812,
    x2: 59.9494,
    y2: 44.8812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_963",
    x1: 62.0367,
    y1: 44.7701,
    x2: 62.7549,
    y2: 44.7701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_963",
    x1: 64.8454,
    y1: 44.8747,
    x2: 65.498,
    y2: 44.8747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_963",
    x1: 56.4442,
    y1: 46.3997,
    x2: 57.1624,
    y2: 46.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_963",
    x1: 59.2429,
    y1: 46.3997,
    x2: 59.9569,
    y2: 46.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_963",
    x1: 62.0367,
    y1: 46.3997,
    x2: 62.7549,
    y2: 46.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_963",
    x1: 64.8355,
    y1: 46.3997,
    x2: 65.5494,
    y2: 46.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_963",
    x1: 67.6319,
    y1: 46.3997,
    x2: 68.3501,
    y2: 46.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_963",
    x1: 53.6497,
    y1: 48.28,
    x2: 54.3636,
    y2: 48.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_963",
    x1: 56.4434,
    y1: 48.2798,
    x2: 57.1617,
    y2: 48.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_963",
    x1: 59.2429,
    y1: 48.2798,
    x2: 59.9569,
    y2: 48.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_963",
    x1: 62.0367,
    y1: 48.2798,
    x2: 62.7549,
    y2: 48.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_963",
    x1: 64.8357,
    y1: 48.28,
    x2: 65.5497,
    y2: 48.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_963",
    x1: 67.6319,
    y1: 48.2798,
    x2: 68.3501,
    y2: 48.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_963",
    x1: 70.4287,
    y1: 48.2798,
    x2: 71.1426,
    y2: 48.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_963",
    x1: 50.9496,
    y1: 50.1808,
    x2: 51.5715,
    y2: 50.1808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_963",
    x1: 53.6497,
    y1: 50.1616,
    x2: 54.3636,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_963",
    x1: 56.4434,
    y1: 50.1616,
    x2: 57.1617,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_963",
    x1: 59.2429,
    y1: 50.1616,
    x2: 59.9569,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_963",
    x1: 62.0367,
    y1: 50.1616,
    x2: 62.7549,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_963",
    x1: 64.8355,
    y1: 50.1616,
    x2: 65.5494,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_963",
    x1: 67.6319,
    y1: 50.1616,
    x2: 68.3501,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_963",
    x1: 70.4287,
    y1: 50.1616,
    x2: 71.1426,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2_963",
    x1: 73.2244,
    y1: 50.1676,
    x2: 73.8857,
    y2: 50.1676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_963",
    x1: 50.8528,
    y1: 52.0436,
    x2: 51.5711,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_963",
    x1: 53.6497,
    y1: 52.0436,
    x2: 54.3636,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2_963",
    x1: 56.4442,
    y1: 52.0436,
    x2: 57.1624,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2_963",
    x1: 59.2429,
    y1: 52.0436,
    x2: 59.9569,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2_963",
    x1: 62.0367,
    y1: 52.0436,
    x2: 62.7549,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2_963",
    x1: 64.8355,
    y1: 52.0436,
    x2: 65.5494,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2_963",
    x1: 67.6319,
    y1: 52.0436,
    x2: 68.3501,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2_963",
    x1: 70.4287,
    y1: 52.0436,
    x2: 71.1426,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2_963",
    x1: 73.2244,
    y1: 52.0436,
    x2: 73.9427,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2_963",
    x1: 50.8528,
    y1: 53.9166,
    x2: 51.5711,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2_963",
    x1: 53.6497,
    y1: 53.9166,
    x2: 54.3636,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2_963",
    x1: 56.4442,
    y1: 53.9166,
    x2: 57.1624,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2_963",
    x1: 59.2429,
    y1: 53.9166,
    x2: 59.9569,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2_963",
    x1: 62.0367,
    y1: 53.9166,
    x2: 62.7549,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2_963",
    x1: 64.8355,
    y1: 53.9166,
    x2: 65.5494,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2_963",
    x1: 67.6319,
    y1: 53.9166,
    x2: 68.3501,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2_963",
    x1: 70.4287,
    y1: 53.9166,
    x2: 71.1426,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2_963",
    x1: 73.2244,
    y1: 53.9166,
    x2: 73.9427,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2_963",
    x1: 48.6678,
    y1: 55.8324,
    x2: 48.9263,
    y2: 55.8324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2_963",
    x1: 50.8528,
    y1: 55.7963,
    x2: 51.5711,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2_963",
    x1: 53.6497,
    y1: 55.7963,
    x2: 54.3636,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2_963",
    x1: 56.4434,
    y1: 55.7963,
    x2: 57.1617,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2_963",
    x1: 59.2429,
    y1: 55.7963,
    x2: 59.9569,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2_963",
    x1: 62.0367,
    y1: 55.7963,
    x2: 62.7549,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2_963",
    x1: 64.8357,
    y1: 55.7963,
    x2: 65.5497,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2_963",
    x1: 67.6319,
    y1: 55.7963,
    x2: 68.3501,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2_963",
    x1: 70.4287,
    y1: 55.7963,
    x2: 71.1426,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2_963",
    x1: 73.2244,
    y1: 55.7963,
    x2: 73.9427,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2_963",
    x1: 75.7445,
    y1: 55.817,
    x2: 76.0861,
    y2: 55.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2_963",
    x1: 48.4567,
    y1: 57.6803,
    x2: 48.9254,
    y2: 57.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2_963",
    x1: 50.8528,
    y1: 57.6843,
    x2: 51.5711,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2_963",
    x1: 53.6497,
    y1: 57.6843,
    x2: 54.3636,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2_963",
    x1: 56.4442,
    y1: 57.6843,
    x2: 57.1624,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2_963",
    x1: 59.2429,
    y1: 57.6843,
    x2: 59.9569,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2_963",
    x1: 62.0367,
    y1: 57.6843,
    x2: 62.7549,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2_963",
    x1: 64.8355,
    y1: 57.6843,
    x2: 65.5494,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2_963",
    x1: 67.6319,
    y1: 57.6843,
    x2: 68.3501,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2_963",
    x1: 70.4287,
    y1: 57.6843,
    x2: 71.1426,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2_963",
    x1: 73.2244,
    y1: 57.6843,
    x2: 73.9427,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2_963",
    x1: 75.7445,
    y1: 57.6812,
    x2: 76.2919,
    y2: 57.6812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2_963",
    x1: 48.4567,
    y1: 59.5623,
    x2: 48.9254,
    y2: 59.5623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2_963",
    x1: 50.8528,
    y1: 59.567,
    x2: 51.5711,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2_963",
    x1: 53.6497,
    y1: 59.567,
    x2: 54.3636,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2_963",
    x1: 56.4434,
    y1: 59.567,
    x2: 57.1617,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2_963",
    x1: 59.2429,
    y1: 59.567,
    x2: 59.9569,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2_963",
    x1: 62.0367,
    y1: 59.567,
    x2: 62.7549,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2_963",
    x1: 64.8355,
    y1: 59.567,
    x2: 65.5494,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2_963",
    x1: 67.6319,
    y1: 59.567,
    x2: 68.3501,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2_963",
    x1: 70.4287,
    y1: 59.567,
    x2: 71.1426,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2_963",
    x1: 73.2244,
    y1: 59.567,
    x2: 73.9427,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2_963",
    x1: 75.7445,
    y1: 59.5623,
    x2: 76.2963,
    y2: 59.5623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2_963",
    x1: 48.6504,
    y1: 61.4179,
    x2: 48.9263,
    y2: 61.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2_963",
    x1: 50.8528,
    y1: 61.4451,
    x2: 51.5711,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2_963",
    x1: 53.6497,
    y1: 61.4451,
    x2: 54.3636,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2_963",
    x1: 56.4442,
    y1: 61.4451,
    x2: 57.1624,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2_963",
    x1: 59.2429,
    y1: 61.4451,
    x2: 59.9569,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2_963",
    x1: 62.0367,
    y1: 61.4451,
    x2: 62.7549,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2_963",
    x1: 64.8355,
    y1: 61.4451,
    x2: 65.5494,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2_963",
    x1: 67.6319,
    y1: 61.4451,
    x2: 68.3501,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2_963",
    x1: 70.4287,
    y1: 61.4451,
    x2: 71.1426,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2_963",
    x1: 73.2244,
    y1: 61.4451,
    x2: 73.9427,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2_963",
    x1: 75.7464,
    y1: 61.4332,
    x2: 76.1011,
    y2: 61.4332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2_963",
    x1: 50.8528,
    y1: 63.3249,
    x2: 51.5711,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2_963",
    x1: 53.6497,
    y1: 63.3249,
    x2: 54.3636,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2_963",
    x1: 56.4442,
    y1: 63.3249,
    x2: 57.1624,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2_963",
    x1: 59.2429,
    y1: 63.3249,
    x2: 59.9569,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2_963",
    x1: 62.0367,
    y1: 63.3249,
    x2: 62.7549,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2_963",
    x1: 64.8355,
    y1: 63.3249,
    x2: 65.5494,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2_963",
    x1: 67.6319,
    y1: 63.3249,
    x2: 68.3501,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2_963",
    x1: 70.4287,
    y1: 63.3249,
    x2: 71.1426,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2_963",
    x1: 73.2244,
    y1: 63.3249,
    x2: 73.9427,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2_963",
    x1: 50.8528,
    y1: 65.2031,
    x2: 51.5711,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2_963",
    x1: 53.6497,
    y1: 65.2031,
    x2: 54.3636,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2_963",
    x1: 56.4442,
    y1: 65.2031,
    x2: 57.1624,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2_963",
    x1: 59.2429,
    y1: 65.2031,
    x2: 59.9569,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2_963",
    x1: 62.0367,
    y1: 65.2031,
    x2: 62.7549,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2_963",
    x1: 64.8355,
    y1: 65.2031,
    x2: 65.5494,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2_963",
    x1: 67.6319,
    y1: 65.2031,
    x2: 68.3501,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2_963",
    x1: 70.4287,
    y1: 65.2031,
    x2: 71.1426,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2_963",
    x1: 73.2244,
    y1: 65.2031,
    x2: 73.9427,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2_963",
    x1: 50.9189,
    y1: 67.0749,
    x2: 51.5715,
    y2: 67.0749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2_963",
    x1: 53.6497,
    y1: 67.0858,
    x2: 54.3636,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2_963",
    x1: 56.4442,
    y1: 67.0858,
    x2: 57.1624,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2_963",
    x1: 59.2429,
    y1: 67.0858,
    x2: 59.9569,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2_963",
    x1: 62.0367,
    y1: 67.0858,
    x2: 62.7549,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2_963",
    x1: 64.8355,
    y1: 67.0858,
    x2: 65.5494,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2_963",
    x1: 67.6319,
    y1: 67.0858,
    x2: 68.3501,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2_963",
    x1: 70.4287,
    y1: 67.0858,
    x2: 71.1426,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2_963",
    x1: 73.2244,
    y1: 67.0836,
    x2: 73.9164,
    y2: 67.0836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2_963",
    x1: 53.6497,
    y1: 68.9657,
    x2: 54.3636,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2_963",
    x1: 56.4442,
    y1: 68.9657,
    x2: 57.1624,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2_963",
    x1: 59.2429,
    y1: 68.9657,
    x2: 59.9569,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2_963",
    x1: 62.0367,
    y1: 68.9657,
    x2: 62.7549,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2_963",
    x1: 64.8355,
    y1: 68.9657,
    x2: 65.5494,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2_963",
    x1: 67.6319,
    y1: 68.9657,
    x2: 68.3501,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2_963",
    x1: 70.4287,
    y1: 68.9657,
    x2: 71.1426,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2_963",
    x1: 56.4434,
    y1: 70.8437,
    x2: 57.1617,
    y2: 70.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2_963",
    x1: 59.2429,
    y1: 70.8437,
    x2: 59.9569,
    y2: 70.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2_963",
    x1: 62.0367,
    y1: 70.8437,
    x2: 62.7549,
    y2: 70.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2_963",
    x1: 64.8355,
    y1: 70.8437,
    x2: 65.5494,
    y2: 70.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2_963",
    x1: 67.6319,
    y1: 70.8437,
    x2: 68.3501,
    y2: 70.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2_963",
    x1: 59.3541,
    y1: 72.4771,
    x2: 59.9322,
    y2: 72.4771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2_963",
    x1: 62.0359,
    y1: 72.588,
    x2: 62.7541,
    y2: 72.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2_963",
    x1: 64.8586,
    y1: 72.4829,
    x2: 65.4542,
    y2: 72.4829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2_963",
    x1: 48.4567,
    y1: 59.5623,
    x2: 48.9254,
    y2: 59.5623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2_963",
    x1: 48.4567,
    y1: 57.6803,
    x2: 48.9254,
    y2: 57.6803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_2_963",
    x1: 48.6504,
    y1: 61.4179,
    x2: 48.9263,
    y2: 61.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_2_963",
    x1: 48.6678,
    y1: 55.8336,
    x2: 48.9263,
    y2: 55.8336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_2_963",
    x1: 50.8528,
    y1: 65.2031,
    x2: 51.5711,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_2_963",
    x1: 50.8528,
    y1: 63.3249,
    x2: 51.5711,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_2_963",
    x1: 50.8528,
    y1: 61.4451,
    x2: 51.5711,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_2_963",
    x1: 50.8528,
    y1: 59.567,
    x2: 51.5711,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_2_963",
    x1: 50.8528,
    y1: 57.6843,
    x2: 51.5711,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_2_963",
    x1: 50.8528,
    y1: 55.7963,
    x2: 51.5711,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_2_963",
    x1: 50.8528,
    y1: 53.9166,
    x2: 51.5711,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_2_963",
    x1: 50.8528,
    y1: 52.0436,
    x2: 51.5711,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_2_963",
    x1: 50.9189,
    y1: 67.0749,
    x2: 51.5715,
    y2: 67.0749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_2_963",
    x1: 50.9496,
    y1: 50.1808,
    x2: 51.5715,
    y2: 50.1808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_2_963",
    x1: 53.6497,
    y1: 68.9657,
    x2: 54.3636,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_2_963",
    x1: 53.6497,
    y1: 67.0858,
    x2: 54.3636,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_2_963",
    x1: 53.6497,
    y1: 65.2031,
    x2: 54.3636,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_2_963",
    x1: 53.6497,
    y1: 63.3249,
    x2: 54.3636,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_2_963",
    x1: 53.6497,
    y1: 61.4451,
    x2: 54.3636,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_2_963",
    x1: 53.6497,
    y1: 59.567,
    x2: 54.3636,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_2_963",
    x1: 53.6497,
    y1: 57.6843,
    x2: 54.3636,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_2_963",
    x1: 53.6497,
    y1: 55.7963,
    x2: 54.3636,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_2_963",
    x1: 53.6497,
    y1: 53.9166,
    x2: 54.3636,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_2_963",
    x1: 53.6497,
    y1: 52.0436,
    x2: 54.3636,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_2_963",
    x1: 53.6497,
    y1: 50.1616,
    x2: 54.3636,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_2_963",
    x1: 53.6497,
    y1: 48.28,
    x2: 54.3636,
    y2: 48.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_2_963",
    x1: 56.4434,
    y1: 70.8437,
    x2: 57.1617,
    y2: 70.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_2_963",
    x1: 56.4442,
    y1: 68.9657,
    x2: 57.1624,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_2_963",
    x1: 56.4442,
    y1: 67.0858,
    x2: 57.1624,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_2_963",
    x1: 56.4442,
    y1: 65.2031,
    x2: 57.1624,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_2_963",
    x1: 56.4442,
    y1: 63.3249,
    x2: 57.1624,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_2_963",
    x1: 56.4442,
    y1: 61.4451,
    x2: 57.1624,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_2_963",
    x1: 56.4434,
    y1: 59.567,
    x2: 57.1617,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_2_963",
    x1: 56.4442,
    y1: 57.6843,
    x2: 57.1624,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_2_963",
    x1: 56.4434,
    y1: 55.7963,
    x2: 57.1617,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_2_963",
    x1: 56.4442,
    y1: 53.9166,
    x2: 57.1624,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_2_963",
    x1: 56.4442,
    y1: 52.0436,
    x2: 57.1624,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_2_963",
    x1: 56.4434,
    y1: 50.1616,
    x2: 57.1617,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_2_963",
    x1: 56.4434,
    y1: 48.2798,
    x2: 57.1617,
    y2: 48.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_2_963",
    x1: 56.4442,
    y1: 46.3997,
    x2: 57.1624,
    y2: 46.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_2_963",
    x1: 59.3091,
    y1: 44.8785,
    x2: 59.9486,
    y2: 44.8785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_2_963",
    x1: 59.2429,
    y1: 70.8437,
    x2: 59.9569,
    y2: 70.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_2_963",
    x1: 59.2429,
    y1: 68.9657,
    x2: 59.9569,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_2_963",
    x1: 59.2429,
    y1: 67.0858,
    x2: 59.9569,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_2_963",
    x1: 59.2429,
    y1: 65.2031,
    x2: 59.9569,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_2_963",
    x1: 59.2429,
    y1: 63.3249,
    x2: 59.9569,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_2_963",
    x1: 59.2429,
    y1: 61.4451,
    x2: 59.9569,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_2_963",
    x1: 59.2429,
    y1: 59.567,
    x2: 59.9569,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_2_963",
    x1: 59.2429,
    y1: 57.6843,
    x2: 59.9569,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_2_963",
    x1: 59.2429,
    y1: 55.7963,
    x2: 59.9569,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_2_963",
    x1: 59.2429,
    y1: 53.9166,
    x2: 59.9569,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_2_963",
    x1: 59.2429,
    y1: 52.0436,
    x2: 59.9569,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_2_963",
    x1: 59.2429,
    y1: 50.1616,
    x2: 59.9569,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_2_963",
    x1: 59.2429,
    y1: 48.2798,
    x2: 59.9569,
    y2: 48.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_2_963",
    x1: 59.2429,
    y1: 46.3997,
    x2: 59.9569,
    y2: 46.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_2_963",
    x1: 59.3541,
    y1: 72.4771,
    x2: 59.9322,
    y2: 72.4771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_2_963",
    x1: 62.0367,
    y1: 70.8437,
    x2: 62.7549,
    y2: 70.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_2_963",
    x1: 62.0367,
    y1: 68.9657,
    x2: 62.7549,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_2_963",
    x1: 62.0367,
    y1: 67.0858,
    x2: 62.7549,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_2_963",
    x1: 62.0367,
    y1: 65.2031,
    x2: 62.7549,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_2_963",
    x1: 62.0367,
    y1: 63.3249,
    x2: 62.7549,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_2_963",
    x1: 62.0367,
    y1: 61.4451,
    x2: 62.7549,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_2_963",
    x1: 62.0367,
    y1: 59.567,
    x2: 62.7549,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_2_963",
    x1: 62.0367,
    y1: 57.6843,
    x2: 62.7549,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_2_963",
    x1: 62.0367,
    y1: 55.7963,
    x2: 62.7549,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_2_963",
    x1: 62.0367,
    y1: 53.9166,
    x2: 62.7549,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_2_963",
    x1: 62.0367,
    y1: 52.0436,
    x2: 62.7549,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_2_963",
    x1: 62.0367,
    y1: 50.1616,
    x2: 62.7549,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_2_963",
    x1: 62.0367,
    y1: 48.2798,
    x2: 62.7549,
    y2: 48.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_2_963",
    x1: 62.0367,
    y1: 46.3997,
    x2: 62.7549,
    y2: 46.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_2_963",
    x1: 62.0374,
    y1: 44.7701,
    x2: 62.7556,
    y2: 44.7701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_2_963",
    x1: 62.0359,
    y1: 72.588,
    x2: 62.7541,
    y2: 72.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_2_963",
    x1: 64.8355,
    y1: 70.8437,
    x2: 65.5494,
    y2: 70.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_2_963",
    x1: 64.8355,
    y1: 68.9657,
    x2: 65.5494,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_2_963",
    x1: 64.8355,
    y1: 67.0858,
    x2: 65.5494,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_2_963",
    x1: 64.8355,
    y1: 65.2031,
    x2: 65.5494,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_2_963",
    x1: 64.8355,
    y1: 63.3249,
    x2: 65.5494,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_2_963",
    x1: 64.8355,
    y1: 61.4451,
    x2: 65.5494,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_2_963",
    x1: 64.8355,
    y1: 59.567,
    x2: 65.5494,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_2_963",
    x1: 64.8355,
    y1: 57.6843,
    x2: 65.5494,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_2_963",
    x1: 64.8357,
    y1: 55.7963,
    x2: 65.5497,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_2_963",
    x1: 64.8355,
    y1: 53.9166,
    x2: 65.5494,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_2_963",
    x1: 64.8355,
    y1: 52.0436,
    x2: 65.5494,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_2_963",
    x1: 64.8355,
    y1: 50.1616,
    x2: 65.5494,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_2_963",
    x1: 64.8357,
    y1: 48.28,
    x2: 65.5497,
    y2: 48.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_2_963",
    x1: 64.8355,
    y1: 46.3997,
    x2: 65.5494,
    y2: 46.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_2_963",
    x1: 64.8586,
    y1: 72.4829,
    x2: 65.4542,
    y2: 72.4829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_2_963",
    x1: 64.8454,
    y1: 44.8747,
    x2: 65.498,
    y2: 44.8747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_2_963",
    x1: 67.6319,
    y1: 70.8437,
    x2: 68.3501,
    y2: 70.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_2_963",
    x1: 67.6319,
    y1: 68.9657,
    x2: 68.3501,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_2_963",
    x1: 67.6319,
    y1: 67.0858,
    x2: 68.3501,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_2_963",
    x1: 67.6319,
    y1: 65.2031,
    x2: 68.3501,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_2_963",
    x1: 67.6319,
    y1: 63.3249,
    x2: 68.3501,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_2_963",
    x1: 67.6319,
    y1: 61.4451,
    x2: 68.3501,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_2_963",
    x1: 67.6319,
    y1: 59.567,
    x2: 68.3501,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_2_963",
    x1: 67.6319,
    y1: 57.6843,
    x2: 68.3501,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_2_963",
    x1: 67.6319,
    y1: 55.7963,
    x2: 68.3501,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_2_963",
    x1: 67.6319,
    y1: 53.9166,
    x2: 68.3501,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_2_963",
    x1: 67.6319,
    y1: 52.0436,
    x2: 68.3501,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_2_963",
    x1: 67.6319,
    y1: 50.1616,
    x2: 68.3501,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_2_963",
    x1: 67.6319,
    y1: 48.2798,
    x2: 68.3501,
    y2: 48.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_2_963",
    x1: 67.6319,
    y1: 46.3997,
    x2: 68.3501,
    y2: 46.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_2_963",
    x1: 70.4287,
    y1: 68.9657,
    x2: 71.1426,
    y2: 68.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_2_963",
    x1: 70.4287,
    y1: 67.0858,
    x2: 71.1426,
    y2: 67.0858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_2_963",
    x1: 70.4287,
    y1: 65.2031,
    x2: 71.1426,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_2_963",
    x1: 70.4287,
    y1: 63.3249,
    x2: 71.1426,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_2_963",
    x1: 70.4287,
    y1: 61.4451,
    x2: 71.1426,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_2_963",
    x1: 70.4287,
    y1: 59.567,
    x2: 71.1426,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_2_963",
    x1: 70.4287,
    y1: 57.6843,
    x2: 71.1426,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_2_963",
    x1: 70.4287,
    y1: 55.7963,
    x2: 71.1426,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_2_963",
    x1: 70.4287,
    y1: 53.9166,
    x2: 71.1426,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_2_963",
    x1: 70.4287,
    y1: 52.0436,
    x2: 71.1426,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_2_963",
    x1: 70.4287,
    y1: 50.1616,
    x2: 71.1426,
    y2: 50.1616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_2_963",
    x1: 70.4287,
    y1: 48.2798,
    x2: 71.1426,
    y2: 48.2798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_2_963",
    x1: 73.2244,
    y1: 65.2031,
    x2: 73.9427,
    y2: 65.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_2_963",
    x1: 73.2244,
    y1: 63.3249,
    x2: 73.9427,
    y2: 63.3249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_2_963",
    x1: 73.2244,
    y1: 61.4451,
    x2: 73.9427,
    y2: 61.4451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_2_963",
    x1: 73.2244,
    y1: 59.567,
    x2: 73.9427,
    y2: 59.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_2_963",
    x1: 73.2244,
    y1: 57.6843,
    x2: 73.9427,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_2_963",
    x1: 73.2244,
    y1: 55.7963,
    x2: 73.9427,
    y2: 55.7963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_2_963",
    x1: 73.2244,
    y1: 53.9166,
    x2: 73.9427,
    y2: 53.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_2_963",
    x1: 73.2244,
    y1: 52.0436,
    x2: 73.9427,
    y2: 52.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_2_963",
    x1: 73.2244,
    y1: 50.1676,
    x2: 73.8857,
    y2: 50.1676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_2_963",
    x1: 73.2244,
    y1: 67.0836,
    x2: 73.9164,
    y2: 67.0836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_2_963",
    x1: 75.7445,
    y1: 55.817,
    x2: 76.0861,
    y2: 55.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_2_963",
    x1: 75.7464,
    y1: 61.4332,
    x2: 76.1011,
    y2: 61.4332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_2_963",
    x1: 75.7445,
    y1: 57.6843,
    x2: 76.2919,
    y2: 57.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_2_963",
    x1: 75.7445,
    y1: 59.5623,
    x2: 76.2963,
    y2: 59.5623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_2_963",
    x1: 49.7512,
    y1: 56.9429,
    x2: 37.894,
    y2: -7.20549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F09FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#813EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_2_963",
    x1: 42.4597,
    y1: 41.3212,
    x2: 43.1657,
    y2: 25.6314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8341FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF84FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceicon3);
export default __webpack_public_path__ + "static/media/priceicon3.f31f7110a622e87a1e9c9491ca028408.svg";
export { ForwardRef as ReactComponent };